<template>
  <div>
    <v-overlay v-model="showSuccess" :scrim="true" opacity="0.3" persistent :z-index="9998"> </v-overlay>
    <!-- Success Toast -->
    <transition name="fade-slide">
      <output v-if="showSuccess" class="success-toast" style="position: fixed; top: 30px; left: 50%; transform: translateX(-50%); z-index: 9999">
        <img src="@/assets/mdi_success-bold.svg" alt="img" width="20" height="20" />
        <span style="font-size: 14px; font-weight: 600">{{ SuccessMessage }}</span>
      </output>
    </transition>

    <v-container fluid>
      <v-card class="card border" style="box-shadow: none !important">
        <v-flex class="flex">
          <!-- Tab Header with Buttons -->
          <v-row class="tab-header-row sticky-header px-0 mb-6 border-0">
            <v-col cols="12" md="9">
              <div class="tab-buttons" style="gap: 12px">
                <v-btn :class="{ 'tab-btn--active': activeTab === 'login' }" variant="outlined" @click="activeTab = 'login'" class="tab-btn">
                  <img src="@/assets/Icons/new_looking_computer.png" alt="looking_computer" width="24" height="24" class="mr-2 tab-btn__icon" />
                  {{ $t('login') }}
                </v-btn>
                <v-btn :class="{ 'tab-btn--active': activeTab === 'chatPanel' }" variant="outlined" @click="activeTab = 'chatPanel'" class="tab-btn">
                  <img src="@/assets/Icons/new_panel_right.png" alt="panel_right" width="24" height="24" class="mr-2 tab-btn__icon" />
                  {{ $t('_ChatPanel') }}
                </v-btn>
                <v-btn :class="{ 'tab-btn--active': activeTab === 'header' }" variant="outlined" @click="activeTab = 'header'" class="tab-btn">
                  <img src="@/assets/Icons/new_dual_screen_header.png" alt="dual_screen_header" width="24" height="24" class="mr-2 tab-btn__icon" />
                  {{ $t('_Header') }}
                </v-btn>
                <v-btn :class="{ 'tab-btn--active': activeTab === 'snipped' }" variant="outlined" @click="activeTab = 'snipped'" class="tab-btn">
                  <img src="@/assets/Icons/new_message_dots.png" alt="message_dots" width="24" height="24" class="mr-2 tab-btn__icon" />
                  {{ $t('_Snippet') }}
                </v-btn>
                <v-btn :class="{ 'tab-btn--active': activeTab === 'fullstream' }" variant="outlined" @click="activeTab = 'fullstream'" class="tab-btn">
                  <v-icon class="mr-2" size="20">mdi-forum-outline</v-icon>
                  {{ $t('_Fullstream') }}
                </v-btn>
              </div>
            </v-col>
            <v-col cols="12" lg="1" class="d-none d-lg-flex justify-center">
              <v-divider vertical thickness="2" length="45" style="background: #c9c9c9; opacity: 1"></v-divider>
            </v-col>
            <v-col cols="12" md="2" class="px-0">
              <div class="action-buttons d-flex" style="gap: 12px">
                <v-btn color="#CDD5F3" id="button-setdefault-configtheme" :loading="dialog" :disabled="dialog" @click="openDefaultDialog()" class="default-btn">
                  <img src="@/assets/Icons/new_reset_left_line.png" alt="reset_left_line" width="24" height="24" />
                  <v-tooltip activator="parent" location="top"> {{ $t('_ResetAll') }} </v-tooltip>
                </v-btn>
                <v-btn color="success" id="button-save-configtheme" :loading="dialog" :disabled="dialog || hasSnippedValidationError" @click="save" data-testid="snipped-save" class="save-btn">
                  <img src="@/assets/Icons/new_save_floppy.svg" alt="save_floppy" width="24" height="24" class="mr-2" />
                  {{ $t('save') }}
                  <v-tooltip activator="parent" location="top"> {{ $t('_SaveTheme') }} </v-tooltip>
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <!-- Tab Content -->
          <div class="tab-content">
            <!-- Login Tab -->
            <div v-show="activeTab === 'login'">
              <v-col cols="12">
                <v-row>
                  <v-col cols="5">
                    <v-card style="box-shadow: none !important; background-color: #ffffff">
                      <div class="d-flex align-center mb-3">
                        <img src="@/assets/Icons/new_color_paint_brush.png" alt="color_paint_brush" width="37" height="37" class="" />
                        <span class="font-weight-bold" style="font-size: 23px">{{ $t('_LoginStyle') }}</span>
                      </div>
                      <div class="style-div">
                        <v-card-title class="text-black px-0 mb-5" style="display: flex; justify-content: space-between"
                          ><span style="font-weight: 600">{{ $t('_Logo') }}</span>
                          <v-btn id="button-setdefault-loginlogo-configtheme" color="#CDD5F3" class="reset-btn" @click="setAsDefault('Loginlogo')">
                            <img src="@/assets/Icons/new_reset_wrench.png" alt="reset_wrench" width="26" height="26" />
                            <v-tooltip activator="parent" location="top"> {{ $t('_SetToDefault') }} </v-tooltip>
                          </v-btn>
                        </v-card-title>
                        <DragDropFile
                          :dialog="true"
                          :DragDrop="true"
                          :accept="'image/*'"
                          :reset="resetLogo"
                          @filesUploaded="onFileChange($event, 'Loginlogo')"
                          :multiple="false"
                          :ShowListFile="false"
                          class="UploadFile"
                        />
                      </div>
                    </v-card>
                  </v-col>
                  <v-col cols="7">
                    <div class="d-flex align-center mb-3">
                      <img src="@/assets/Icons/new_color_content_view.png" alt="color_paint_brush" width="37" height="37" class="mr-2" />
                      <span class="font-weight-bold" style="font-size: 23px">{{ $t('_Preview') }}</span>
                    </div>
                    <v-card style="background-color: #ffffff; height: 400px; box-shadow: rgba(0, 0, 0, 0.11) 0px 4px 22px !important; border-radius: 12px" class="pa-8">
                      <div style="text-align: center">
                        <v-row justify="center" class="img-intersection">
                          <v-col cols="12" style="position: relative; min-height: 350px; border-radius: 16px">
                            <LoginStyle :logo="images.Loginlogo" />
                          </v-col>
                        </v-row>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </div>

            <!-- Chat Panel Tab -->
            <div v-show="activeTab === 'chatPanel'">
              <v-col cols="12">
                <v-row>
                  <v-col cols="5">
                    <v-card style="box-shadow: none !important; background-color: #ffffff">
                      <div class="d-flex align-center mb-3">
                        <img src="@/assets/Icons/new_color_paint_brush.png" alt="color_paint_brush" width="37" height="37" class="" />
                        <span class="font-weight-bold" style="font-size: 23px">{{ $t('_ChatPanelStyle') }}</span>
                      </div>
                      <div class="style-div chatpanel-style-div">
                        <v-card-title class="text-black px-0 mb-5" style="display: flex; justify-content: space-between"
                          ><span style="font-weight: 600">{{ $t('_ChatColor') }}</span>
                          <v-btn id="button-setdefault-chatcolor-configtheme" color="#CDD5F3" class="reset-btn" @click="setAsDefault('ChatColor')">
                            <img src="@/assets/Icons/new_reset_wrench.png" alt="reset_wrench" width="26" height="26" />
                            <v-tooltip activator="parent" location="top"> {{ $t('_SetToDefault') }} </v-tooltip>
                          </v-btn>
                        </v-card-title>
                        <v-color-picker
                          id="chatcolortheme-chatpanel-configtheme"
                          :key="'cp-chatcolor-' + colorPickerKey"
                          v-model="ConfigData.chatColorTheme"
                          mode="hex"
                          width="100%"
                          hide-mode-switch
                          show-swatches
                          :swatches="swatches"
                        >
                        </v-color-picker>

                        <v-card-title class="text-black px-0 mb-5 mt-6" style="display: flex; justify-content: space-between"
                          ><span style="font-weight: 600">{{ $t('_FontColor') }}</span>
                          <v-btn color="#CDD5F3" class="reset-btn" @click="setAsDefault('ChatPanelFontColor')">
                            <img src="@/assets/Icons/new_reset_wrench.png" alt="reset_wrench" width="26" height="26" />
                            <v-tooltip activator="parent" location="top"> {{ $t('_SetToDefault') }} </v-tooltip>
                          </v-btn>
                        </v-card-title>
                        <v-color-picker
                          :key="'cp-chatpanelfont-' + colorPickerKey"
                          v-model="ConfigData.ChatPanelFontColorTheme"
                          mode="hex"
                          width="100%"
                          hide-mode-switch
                          show-swatches
                          :swatches="swatches"
                        >
                        </v-color-picker>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col cols="7" class="d-flex" style="flex-direction: column">
                    <div class="d-flex align-center mb-3">
                      <img src="@/assets/Icons/new_color_content_view.png" alt="color_paint_brush" width="37" height="37" class="mr-2" />
                      <span class="font-weight-bold" style="font-size: 23px">{{ $t('_ChatColorPreview') }}</span>
                    </div>
                    <div
                      class="d-flex flex-column pa-4 rounded-lg"
                      style="width: 100%; height: 480px; max-height: 520px; overflow: hidden; box-shadow: 0px 4px 22px rgba(0, 0, 0, 0.11) !important; border-radius: 12px !important"
                      ref="LeftChat"
                    >
                      <div v-for="(item, index) in listMessage" v-bind:key="index" class="px-4 py-3">
                        <div class="d-flex flex-column justify-start mb-4">
                          <div class="float-left" style="max-width: 80%">
                            <span
                              class="rounded-lg rounded-tr-0"
                              style="
                                line-break: loose;
                                padding: 10px 14px;
                                font-size: 14px;
                                font-weight: 400;
                                color: #6e6e76;
                                float: left;
                                border-radius: 16px !important;
                                background-color: #f5f5f5;
                                line-height: 22px;
                                white-space: pre-line;
                                width: fit-content;
                                min-height: 45px;
                              "
                              >{{ item.messageBot }}</span
                            >
                          </div>
                        </div>

                        <div class="d-flex justify-end mb-4">
                          <div class="float-right d-flex" style="max-width: 80%; border-radius: 16px">
                            <span
                              class="rounded-lg rounded-tr-0"
                              style="
                                line-break: loose;
                                padding: 12px 16px;
                                font-size: 14px;
                                font-weight: 400;
                                float: right;
                                line-height: 22px;
                                white-space: pre-line;
                                width: fit-content;
                                min-height: 54px;
                              "
                              :style="{ backgroundColor: ConfigData.chatColorTheme, color: ConfigData.ChatPanelFontColorTheme }"
                              >{{ item.messageUser }}</span
                            >
                            <img src="@/assets/Icons/new_vector.png" alt="vector" width="30" height="30" class="ml-2" />
                          </div>
                        </div>
                      </div>
                      <div ref="endLeft"></div>
                    </div>

                    <div class="d-flex align-center mb-3 mt-6">
                      <img src="@/assets/Icons/new_color_content_view.png" alt="color_paint_brush" width="37" height="37" class="mr-2" />
                      <span class="font-weight-bold" style="font-size: 23px">{{ $t('_FontColorPreview') }}</span>
                    </div>
                    <div
                      class="d-flex flex-column pa-4 rounded-lg"
                      style="width: 100%; height: 480px; max-height: 520px; overflow: hidden; box-shadow: 0px 4px 22px rgba(0, 0, 0, 0.11) !important; border-radius: 12px !important"
                    >
                      <div v-for="(item, index) in listMessage" v-bind:key="'font-' + index" class="px-4 py-3">
                        <div class="d-flex flex-column justify-start mb-4">
                          <div class="float-left" style="max-width: 80%">
                            <span
                              class="rounded-lg rounded-tr-0"
                              style="
                                line-break: loose;
                                padding: 10px 14px;
                                font-size: 14px;
                                font-weight: 400;
                                color: #6e6e76;
                                float: left;
                                border-radius: 16px !important;
                                background-color: #f5f5f5;
                                line-height: 22px;
                                white-space: pre-line;
                                width: fit-content;
                                min-height: 45px;
                              "
                              >{{ item.messageBot }}</span
                            >
                          </div>
                        </div>

                        <div class="d-flex justify-end mb-4">
                          <div class="float-right d-flex" style="max-width: 80%; border-radius: 16px">
                            <span
                              class="rounded-lg rounded-tr-0"
                              style="
                                line-break: loose;
                                padding: 12px 16px;
                                font-size: 14px;
                                font-weight: 400;
                                float: right;
                                line-height: 22px;
                                white-space: pre-line;
                                width: fit-content;
                                min-height: 54px;
                              "
                              :style="{ backgroundColor: ConfigData.chatColorTheme, color: ConfigData.ChatPanelFontColorTheme }"
                              >{{ item.messageUser }}</span
                            >
                            <img src="@/assets/Icons/new_vector.png" alt="vector" width="30" height="30" class="ml-2" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </div>

            <!-- Header Tab -->
            <div v-show="activeTab === 'header'">
              <v-col cols="12">
                <v-row>
                  <v-col cols="5">
                    <v-card style="box-shadow: none !important; background-color: #ffffff">
                      <div class="style-div" style="height: 500px !important">
                        <v-card-title class="text-black px-0 mb-5" style="display: flex; justify-content: space-between">
                          <span style="font-weight: 600">{{ $t('headerLogo') }}</span>
                          <v-btn id="button-setdefault-navlogo-configtheme" color="#CDD5F3" class="reset-btn" @click="setAsDefault('NavLogo')">
                            <img src="@/assets/Icons/new_reset_wrench.png" alt="reset_wrench" width="26" height="26" />
                            <v-tooltip activator="parent" location="top"> {{ $t('_SetToDefault') }} </v-tooltip>
                          </v-btn>
                        </v-card-title>
                        <DragDropFile
                          :dialog="true"
                          :DragDrop="true"
                          :accept="'image/*'"
                          :reset="resetHeaderLogo"
                          @filesUploaded="onFileChange($event, 'NavLogo')"
                          :multiple="false"
                          :ShowListFile="false"
                          class="UploadFile"
                        />
                      </div>
                    </v-card>
                  </v-col>
                  <v-col cols="7">
                    <v-card style="background-color: #ffffff; box-shadow: rgba(0, 0, 0, 0.11) 0px 4px 22px !important; border-radius: 12px; height: 500px" class="pa-8">
                      <div style="border: 1px solid #e0e0e0; border-radius: 12px; height: 100%; overflow: hidden">
                        <ServiceThemePreview
                          :logo="images.navlogo"
                          :buttonColor="ConfigData.NavbarBtnColorTheme"
                          :headerColor="ConfigData.NavbarTxtColorTheme"
                          :headerBg="images.navBG"
                          :titleColor="ConfigData.FontColorTitle"
                          :titleBg="images.subNavBG"
                        />
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </div>

            <!-- Title Tab -->
            <div v-show="activeTab === 'title'" v-if="false">
              <v-col cols="12">
                <v-row>
                  <v-col cols="5">
                    <v-card style="box-shadow: none !important; background-color: #ffffff">
                      <div class="d-flex align-center mb-3">
                        <img src="@/assets/Icons/new_color_paint_brush.png" alt="color_paint_brush" width="37" height="37" class="" />
                        <span class="font-weight-bold" style="font-size: 23px">{{ $t('_TitleStyle') }}</span>
                      </div>
                      <div class="style-div" style="height: 500px !important">
                        <v-card-title class="text-black px-0 mb-5" style="display: flex; justify-content: space-between">
                          <span style="font-weight: 600">{{ $t('_FontColor') }}</span>
                          <v-btn id="button-setdefault-fontcolor-configtheme" color="#CDD5F3" class="reset-btn" @click="setAsDefault('FontColor')">
                            <img src="@/assets/Icons/new_reset_wrench.png" alt="reset_wrench" width="26" height="26" />
                            <v-tooltip activator="parent" location="top"> {{ $t('_SetToDefault') }} </v-tooltip>
                          </v-btn>
                        </v-card-title>
                        <v-color-picker id="titlebtncolortheme-header-configtheme" v-model="ConfigData.FontColorTitle" mode="hex" width="100%" hide-mode-switch show-swatches :swatches="swatches">
                        </v-color-picker>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col cols="7">
                    <div class="d-flex align-center mb-3">
                      <img src="@/assets/Icons/new_color_content_view.png" alt="color_paint_brush" width="37" height="37" class="mr-2" />
                      <span class="font-weight-bold" style="font-size: 23px">{{ $t('_Preview') }}</span>
                    </div>
                    <v-card style="background-color: #ffffff; box-shadow: rgba(0, 0, 0, 0.11) 0px 4px 22px !important; border-radius: 12px; height: 500px" class="pa-8">
                      <div style="border: 1px solid #e0e0e0; border-radius: 12px; height: 100%; overflow: hidden">
                        <ServiceThemePreview
                          :logo="images.navlogo"
                          :buttonColor="ConfigData.NavbarBtnColorTheme"
                          :headerColor="ConfigData.NavbarTxtColorTheme"
                          :headerBg="images.navBG"
                          :titleColor="ConfigData.FontColorTitle"
                          :titleBg="images.subNavBG"
                        />
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="5">
                    <v-card style="box-shadow: none !important; background-color: #ffffff">
                      <div class="style-div" style="height: 500px !important">
                        <v-card-title class="text-black px-0 mb-5" style="display: flex; justify-content: space-between">
                          <span style="font-weight: 600">{{ $t('background') }}</span>
                          <v-btn id="button-setdefault-subbg-configtheme" color="#CDD5F3" class="reset-btn" @click="setAsDefault('SubBG')">
                            <img src="@/assets/Icons/new_reset_wrench.png" alt="reset_wrench" width="26" height="26" />
                            <v-tooltip activator="parent" location="top"> {{ $t('_SetToDefault') }} </v-tooltip>
                          </v-btn>
                        </v-card-title>
                        <DragDropFile
                          :dialog="true"
                          :DragDrop="true"
                          :accept="'image/*'"
                          :reset="resetTitleBg"
                          @filesUploaded="onFileChange($event, 'SubBG')"
                          :multiple="false"
                          :ShowListFile="false"
                          class="UploadFile"
                        />
                      </div>
                    </v-card>
                  </v-col>
                  <v-col cols="7">
                    <v-card style="background-color: #ffffff; box-shadow: rgba(0, 0, 0, 0.11) 0px 4px 22px !important; border-radius: 12px; height: 500px" class="pa-8">
                      <div style="border: 1px solid #e0e0e0; border-radius: 12px; height: 100%; overflow: hidden">
                        <ServiceThemePreview
                          :logo="images.navlogo"
                          :buttonColor="ConfigData.NavbarBtnColorTheme"
                          :headerColor="ConfigData.NavbarTxtColorTheme"
                          :headerBg="images.navBG"
                          :titleColor="ConfigData.FontColorTitle"
                          :titleBg="images.subNavBG"
                        />
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </div>

            <!-- Snipped Tab -->
            <div v-show="activeTab === 'snipped'">
              <v-col cols="12">
                <v-row class="snippet-tab-row">
                  <!-- Preview: single sticky preview on the left -->
                  <v-col cols="12" md="7" class="snippet-preview-col">
                    <div class="d-flex align-center mb-3">
                      <img src="@/assets/Icons/new_color_content_view.png" alt="color_paint_brush" width="37" height="37" class="mr-2" />
                      <span class="font-weight-bold" style="font-size: 23px">{{ $t('_Preview') }}</span>
                    </div>
                    <v-card class="dialog_div snippet-preview-card">
                      <SnippedPreview v-bind="snippedPreviewProps" />
                    </v-card>
                  </v-col>
                  <!-- Settings: scrollable stacked groups on the right.
                       Order mirrors the supalai layout: Branding & Header → Chat Panel → Launcher → Greeting Bubble.
                       Every panel-level control lives in the single "Chat Panel" card with a small
                       fullstream-control-label, and each visibility switch sits next to the control it hides. -->
                  <v-col cols="12" md="5" class="snippet-settings-col">
                    <div class="d-flex align-center mb-3">
                      <img src="@/assets/Icons/new_color_paint_brush.png" alt="color_paint_brush" width="37" height="37" class="" />
                      <span class="font-weight-bold" style="font-size: 23px">{{ $t('_SnippetStyle') }}</span>
                    </div>
                    <div class="d-flex align-center mb-3">
                      <span class="font-weight-bold" style="font-size: 18px">{{ $t('_BrandingAndHeader') }}</span>
                    </div>

                    <!-- ① Branding & Header -->
                    <v-card style="box-shadow: none !important; background-color: #ffffff">
                      <div class="style-div" style="height: auto">
                        <v-card-title class="text-black px-0 mb-5" style="display: flex; justify-content: space-between">
                          <span style="font-weight: 600">{{ $t('_Logo') }}</span>
                          <v-btn id="button-setdefault-snippedlogo-configtheme" color="#CDD5F3" class="reset-btn" @click="setAsDefault('Snippedlogo')">
                            <img src="@/assets/Icons/new_reset_wrench.png" alt="reset_wrench" width="26" height="26" />
                            <v-tooltip activator="parent" location="top"> {{ $t('_SetToDefault') }} </v-tooltip>
                          </v-btn>
                        </v-card-title>
                        <DragDropFile
                          :dialog="true"
                          :DragDrop="true"
                          :accept="'image/*'"
                          :reset="resetSnippedLogo"
                          @filesUploaded="onFileChange($event, 'Snippedlogo')"
                          :multiple="false"
                          :ShowListFile="false"
                          class="UploadFile"
                        />
                      </div>
                    </v-card>

                    <!-- ② Chat Panel -->
                    <v-card style="box-shadow: none !important; background-color: #ffffff" class="mt-4">
                      <div class="d-flex align-center mb-3">
                        <img src="@/assets/Icons/new_color_paint_brush.png" alt="color_paint_brush" width="37" height="37" class="mr-2" />
                        <span class="font-weight-bold" style="font-size: 23px">{{ $t('_ChatPanel') }}</span>
                      </div>
                      <div class="style-div" style="height: auto !important; padding-bottom: 16px">
                        <div class="fullstream-control-group">
                          <div class="fullstream-control-header mb-2">
                            <label class="fullstream-control-label mb-0" for="snipped-header-color">{{ $t('_HeaderColor') }}</label>
                            <v-btn color="#CDD5F3" class="reset-btn fullstream-mini-reset" @click="setAsDefault('SnippedHeaderColor')">
                              <img src="@/assets/Icons/new_reset_wrench.png" alt="reset_wrench" width="18" height="18" />
                              <v-tooltip activator="parent" location="top"> {{ $t('_SetToDefault') }} </v-tooltip>
                            </v-btn>
                          </div>
                          <v-text-field
                            v-model="ConfigData.SnippedHeaderColorTheme"
                            :rules="[hexColorRule]"
                            placeholder="#RRGGBB"
                            variant="outlined"
                            density="comfortable"
                            hide-details="auto"
                            bg-color="white"
                            clearable
                            id="snipped-header-color"
                            data-testid="snipped-header-color"
                          >
                            <template #prepend-inner>
                              <v-menu :close-on-content-click="false" location="bottom start" offset="8">
                                <template #activator="{ props }">
                                  <span
                                    class="snipped-color-swatch snipped-color-swatch--clickable"
                                    :style="{ backgroundColor: swatchColor(ConfigData.SnippedHeaderColorTheme) }"
                                    v-bind="props"
                                  ></span>
                                </template>
                                <v-color-picker
                                  :model-value="ConfigData.SnippedHeaderColorTheme || '#FFFFFF'"
                                  @update:model-value="ConfigData.SnippedHeaderColorTheme = ($event || '').slice(0, 7)"
                                  mode="hex"
                                  hide-mode-switch
                                  show-swatches
                                  :swatches="swatches"
                                ></v-color-picker>
                              </v-menu>
                            </template>
                          </v-text-field>
                        </div>

                        <div class="fullstream-control-group">
                          <div class="fullstream-control-header mb-2">
                            <label class="fullstream-control-label mb-0" for="snipped-font-color">{{ $t('_FontColorUser') }}</label>
                            <v-btn color="#CDD5F3" class="reset-btn fullstream-mini-reset" @click="setAsDefault('SnippedFontColor')">
                              <img src="@/assets/Icons/new_reset_wrench.png" alt="reset_wrench" width="18" height="18" />
                              <v-tooltip activator="parent" location="top"> {{ $t('_SetToDefault') }} </v-tooltip>
                            </v-btn>
                          </div>
                          <v-text-field
                            v-model="ConfigData.SnippedFontColorTheme"
                            :rules="[hexColorRule]"
                            placeholder="#RRGGBB"
                            variant="outlined"
                            density="comfortable"
                            hide-details="auto"
                            bg-color="white"
                            clearable
                            id="snipped-font-color"
                            data-testid="snipped-font-color"
                          >
                            <template #prepend-inner>
                              <v-menu :close-on-content-click="false" location="bottom start" offset="8">
                                <template #activator="{ props }">
                                  <span
                                    class="snipped-color-swatch snipped-color-swatch--clickable"
                                    :style="{ backgroundColor: swatchColor(ConfigData.SnippedFontColorTheme) }"
                                    v-bind="props"
                                  ></span>
                                </template>
                                <v-color-picker
                                  :model-value="ConfigData.SnippedFontColorTheme || '#FFFFFF'"
                                  @update:model-value="ConfigData.SnippedFontColorTheme = ($event || '').slice(0, 7)"
                                  mode="hex"
                                  hide-mode-switch
                                  show-swatches
                                  :swatches="swatches"
                                ></v-color-picker>
                              </v-menu>
                            </template>
                          </v-text-field>
                        </div>

                        <div class="fullstream-control-group">
                          <div class="fullstream-control-header mb-2">
                            <label class="fullstream-control-label mb-0" for="snipped-botfont-color">{{ $t('_BotFontColor') }}</label>
                            <v-btn color="#CDD5F3" class="reset-btn fullstream-mini-reset" @click="setAsDefault('SnippedBotFontColor')">
                              <img src="@/assets/Icons/new_reset_wrench.png" alt="reset_wrench" width="18" height="18" />
                              <v-tooltip activator="parent" location="top"> {{ $t('_ResetBotFontColor') }} </v-tooltip>
                            </v-btn>
                          </div>
                          <v-text-field
                            v-model="ConfigData.SnippedBotFontColor"
                            :rules="[hexColorRule]"
                            placeholder="#RRGGBB"
                            variant="outlined"
                            density="comfortable"
                            hide-details="auto"
                            bg-color="white"
                            clearable
                            id="snipped-botfont-color"
                            data-testid="snipped-botfont-color"
                          >
                            <template #prepend-inner>
                              <v-menu :close-on-content-click="false" location="bottom start" offset="8">
                                <template #activator="{ props }">
                                  <span
                                    class="snipped-color-swatch snipped-color-swatch--clickable"
                                    :style="{ backgroundColor: swatchColor(ConfigData.SnippedBotFontColor) }"
                                    v-bind="props"
                                  ></span>
                                </template>
                                <v-color-picker
                                  :model-value="ConfigData.SnippedBotFontColor || '#FFFFFF'"
                                  @update:model-value="ConfigData.SnippedBotFontColor = ($event || '').slice(0, 7)"
                                  mode="hex"
                                  hide-mode-switch
                                  show-swatches
                                  :swatches="swatches"
                                ></v-color-picker>
                              </v-menu>
                            </template>
                          </v-text-field>
                          <span class="snipped-control-hint">{{ $t('_HintBotFontColor') }}</span>
                        </div>

                        <div class="fullstream-control-group">
                          <label class="fullstream-control-label" for="snipped-bot-name">{{ $t('_BotName') }}</label>
                          <v-text-field
                            v-model="ConfigData.ChatbotName"
                            variant="outlined"
                            density="comfortable"
                            hide-details="auto"
                            bg-color="white"
                            id="snipped-bot-name"
                            data-testid="snipped-bot-name"
                          ></v-text-field>
                          <span class="snipped-control-hint">{{ $t('_HintBotNameShared') }}</span>
                        </div>
                        <div class="fullstream-control-group">
                          <v-switch
                            v-model="ConfigData.SnippedShowBotName"
                            :label="$t('_ShowBotName')"
                            color="primary"
                            density="comfortable"
                            hide-details
                            inset
                            data-testid="snipped-show-botname"
                          ></v-switch>
                        </div>

                        <div class="fullstream-control-group">
                          <label class="fullstream-control-label" for="snipped-header-subtitle">{{ $t('_HeaderSubtitle') }}</label>
                          <v-text-field
                            v-model="ConfigData.SnippedHeaderSubtitle"
                            variant="outlined"
                            density="comfortable"
                            hide-details="auto"
                            bg-color="white"
                            id="snipped-header-subtitle"
                            data-testid="snipped-header-subtitle"
                          ></v-text-field>
                        </div>
                        <div class="fullstream-control-group">
                          <v-switch
                            v-model="ConfigData.SnippedShowHeaderSubtitle"
                            :label="$t('_ShowHeaderSubtitle')"
                            color="primary"
                            density="comfortable"
                            hide-details
                            inset
                            data-testid="snipped-show-headersubtitle"
                          ></v-switch>
                        </div>

                        <div class="fullstream-control-group">
                          <div class="fullstream-control-header mb-2">
                            <label class="fullstream-control-label mb-0" for="snipped-icon-color">{{ $t('_IconColor') }}</label>
                            <v-btn color="#CDD5F3" class="reset-btn fullstream-mini-reset" @click="setAsDefault('SnippedIconColor')">
                              <img src="@/assets/Icons/new_reset_wrench.png" alt="reset_wrench" width="18" height="18" />
                              <v-tooltip activator="parent" location="top"> {{ $t('_SetToDefault') }} </v-tooltip>
                            </v-btn>
                          </div>
                          <v-text-field
                            v-model="ConfigData.SnippedIconColor"
                            :rules="[hexColorRule]"
                            placeholder="#RRGGBB"
                            variant="outlined"
                            density="comfortable"
                            hide-details="auto"
                            bg-color="white"
                            clearable
                            id="snipped-icon-color"
                            data-testid="snipped-icon-color"
                          >
                            <template #prepend-inner>
                              <v-menu :close-on-content-click="false" location="bottom start" offset="8">
                                <template #activator="{ props }">
                                  <span
                                    class="snipped-color-swatch snipped-color-swatch--clickable"
                                    :style="{ backgroundColor: swatchColor(ConfigData.SnippedIconColor) }"
                                    v-bind="props"
                                  ></span>
                                </template>
                                <v-color-picker
                                  :model-value="ConfigData.SnippedIconColor || '#FFFFFF'"
                                  @update:model-value="ConfigData.SnippedIconColor = ($event || '').slice(0, 7)"
                                  mode="hex"
                                  hide-mode-switch
                                  show-swatches
                                  :swatches="swatches"
                                ></v-color-picker>
                              </v-menu>
                            </template>
                          </v-text-field>

                          <div class="chatbot-icon-selector mt-6" :class="{ 'chatbot-icon-selector--icon-off': !isSnippedIconEnabled }">
                            <div class="chatbot-icon-selector__header">
                              <div class="chatbot-icon-selector__preview" :style="{ backgroundColor: '#ffffff' }">
                                <v-img v-if="isSnippedIconEnabled && shouldUseSnippedIconImage" :src="snippedIconPreviewSource" cover class="chatbot-icon-selector__image" />
                                <v-icon v-else-if="isSnippedIconEnabled" size="24" :style="snippedIconPreviewStyle">{{ ConfigData.SnippedIcon }}</v-icon>
                              </div>
                              <div class="chatbot-icon-selector__text">
                                <label>{{ $t('_SnippetIcon') }}</label>
                                <span>{{ $t('_SelectIconOrUploadImage') }}</span>
                              </div>
                              <!-- ไม่มีสวิตช์ on/off ที่นี่ — การซ่อนไอคอนคุมด้วย "Show Snippet Icon" ด้านล่าง
                                   (สวิตช์เดิมล้างค่าไอคอนทิ้ง ซึ่งซ้ำซ้อนและกู้คืนไม่ได้) -->
                              <div class="chatbot-icon-selector__actions">
                                <v-btn color="#CDD5F3" class="reset-btn fullstream-mini-reset" @click="setAsDefault('SnippedIcon')">
                                  <img src="@/assets/Icons/new_reset_wrench.png" alt="reset_wrench" width="18" height="18" />
                                  <v-tooltip activator="parent" location="top"> {{ $t('_ResetSnippetIcon') }} </v-tooltip>
                                </v-btn>
                              </div>
                            </div>
                            <div class="chatbot-icon-selector__grid">
                              <button
                                v-for="item in selectableChatbotIcons"
                                :key="'snipped-' + item.icon"
                                type="button"
                                class="chatbot-icon-option"
                                :class="{ 'chatbot-icon-option--active': isSnippedIconEnabled && !shouldUseSnippedIconImage && ConfigData.SnippedIcon === item.icon }"
                                :style="snippedIconPreviewStyle"
                                @click="selectSnippedIcon(item.icon)"
                              >
                                <v-icon size="22">{{ item.icon }}</v-icon>
                              </button>
                              <label
                                class="chatbot-icon-option chatbot-icon-option--upload"
                                :class="{ 'chatbot-icon-option--active': isSnippedIconEnabled && shouldUseSnippedIconImage }"
                                for="snipped-img-upload"
                                :style="snippedIconPreviewStyle"
                              >
                                <v-icon size="22">mdi-image-plus-outline</v-icon>
                                <input type="file" id="snipped-img-upload" name="snipped-avatar" class="d-none" accept="image/*" @change="inputSnippedIcon($event)" />
                              </label>
                            </div>
                          </div>
                        </div>
                        <div class="fullstream-control-group">
                          <v-switch
                            v-model="ConfigData.SnippedShowSnippedIcon"
                            :label="$t('_ShowSnippetIcon')"
                            color="primary"
                            density="comfortable"
                            hide-details
                            inset
                            data-testid="snipped-show-snippedicon"
                          ></v-switch>
                        </div>

                        <div class="fullstream-control-group">
                          <div class="fullstream-control-header mb-2">
                            <label class="fullstream-control-label mb-0" for="snippedcolortheme-snipped-configtheme">{{ $t('_UserBubbleColor') }}</label>
                            <v-btn id="button-setdefault-snipped-configtheme" color="#CDD5F3" class="reset-btn fullstream-mini-reset" @click="setAsDefault('SnippedColor')">
                              <img src="@/assets/Icons/new_reset_wrench.png" alt="reset_wrench" width="18" height="18" />
                              <v-tooltip activator="parent" location="top"> {{ $t('_SetToDefault') }} </v-tooltip>
                            </v-btn>
                          </div>
                          <v-text-field
                            id="snippedcolortheme-snipped-configtheme"
                            v-model="ConfigData.snippedColorThemeChat"
                            :rules="[hexColorRule]"
                            placeholder="#RRGGBB"
                            variant="outlined"
                            density="comfortable"
                            hide-details="auto"
                            bg-color="white"
                            clearable
                            data-testid="snipped-chat-color"
                          >
                            <template #prepend-inner>
                              <v-menu :close-on-content-click="false" location="bottom start" offset="8">
                                <template #activator="{ props }">
                                  <span
                                    class="snipped-color-swatch snipped-color-swatch--clickable"
                                    :style="{ backgroundColor: swatchColor(ConfigData.snippedColorThemeChat) }"
                                    v-bind="props"
                                  ></span>
                                </template>
                                <v-color-picker
                                  :model-value="ConfigData.snippedColorThemeChat || '#FFFFFF'"
                                  @update:model-value="ConfigData.snippedColorThemeChat = ($event || '').slice(0, 7)"
                                  mode="hex"
                                  hide-mode-switch
                                  show-swatches
                                  :swatches="swatches"
                                ></v-color-picker>
                              </v-menu>
                            </template>
                          </v-text-field>
                        </div>

                        <div class="fullstream-control-group">
                          <div class="fullstream-control-header mb-2">
                            <label class="fullstream-control-label mb-0" for="snipped-botbubble-color">{{ $t('_BotBubbleColor') }}</label>
                            <v-btn color="#CDD5F3" class="reset-btn fullstream-mini-reset" @click="setAsDefault('SnippedBotBubbleColor')">
                              <img src="@/assets/Icons/new_reset_wrench.png" alt="reset_wrench" width="18" height="18" />
                              <v-tooltip activator="parent" location="top"> {{ $t('_ResetBotBubbleColor') }} </v-tooltip>
                            </v-btn>
                          </div>
                          <v-text-field
                            v-model="ConfigData.SnippedBotBubbleColor"
                            :rules="[hexColorRule]"
                            placeholder="#RRGGBB"
                            variant="outlined"
                            density="comfortable"
                            hide-details="auto"
                            bg-color="white"
                            clearable
                            id="snipped-botbubble-color"
                            data-testid="snipped-botbubble-color"
                          >
                            <template #prepend-inner>
                              <v-menu :close-on-content-click="false" location="bottom start" offset="8">
                                <template #activator="{ props }">
                                  <span
                                    class="snipped-color-swatch snipped-color-swatch--clickable"
                                    :style="{ backgroundColor: swatchColor(ConfigData.SnippedBotBubbleColor) }"
                                    v-bind="props"
                                  ></span>
                                </template>
                                <v-color-picker
                                  :model-value="ConfigData.SnippedBotBubbleColor || '#FFFFFF'"
                                  @update:model-value="ConfigData.SnippedBotBubbleColor = ($event || '').slice(0, 7)"
                                  mode="hex"
                                  hide-mode-switch
                                  show-swatches
                                  :swatches="swatches"
                                ></v-color-picker>
                              </v-menu>
                            </template>
                          </v-text-field>
                        </div>

                        <div class="fullstream-control-group">
                          <div class="fullstream-control-header mb-2">
                            <label class="fullstream-control-label mb-0" for="snipped-panel-bordercolor">{{ $t('_PanelBorder') }}</label>
                            <v-btn color="#CDD5F3" class="reset-btn fullstream-mini-reset" @click="setAsDefault('SnippedPanelBorderColor')">
                              <img src="@/assets/Icons/new_reset_wrench.png" alt="reset_wrench" width="18" height="18" />
                              <v-tooltip activator="parent" location="top">{{ $t('_ResetPanelBorder') }}</v-tooltip>
                            </v-btn>
                          </div>
                          <v-text-field
                            v-model="ConfigData.SnippedPanelBorderColor"
                            :rules="[hexColorRule]"
                            :placeholder="$t('_PlaceholderNoBorder')"
                            variant="outlined"
                            density="comfortable"
                            hide-details="auto"
                            bg-color="white"
                            clearable
                            id="snipped-panel-bordercolor"
                            data-testid="snipped-panel-bordercolor"
                          >
                            <template #prepend-inner>
                              <v-menu :close-on-content-click="false" location="bottom start" offset="8">
                                <template #activator="{ props }">
                                  <span
                                    class="snipped-color-swatch snipped-color-swatch--clickable"
                                    :style="{ backgroundColor: swatchColor(ConfigData.SnippedPanelBorderColor) }"
                                    v-bind="props"
                                  ></span>
                                </template>
                                <v-color-picker
                                  :model-value="ConfigData.SnippedPanelBorderColor || '#FFFFFF'"
                                  @update:model-value="ConfigData.SnippedPanelBorderColor = ($event || '').slice(0, 7)"
                                  mode="hex"
                                  hide-mode-switch
                                  show-swatches
                                  :swatches="swatches"
                                ></v-color-picker>
                              </v-menu>
                            </template>
                          </v-text-field>
                        </div>

                        <!-- S1-P2 Panel height — คุมความสูง iframe ตอนยังไม่กด FullSize (loader อ่าน snippedPanelHeightMode/px) -->
                        <div class="fullstream-control-group">
                          <label class="fullstream-control-label" for="snipped-panel-height-mode">{{ $t('_PanelHeight') }}</label>
                          <v-btn-toggle
                            v-model="ConfigData.SnippedPanelHeightMode"
                            mandatory
                            density="compact"
                            variant="outlined"
                            id="snipped-panel-height-mode"
                            data-testid="snipped-panel-height-mode"
                            role="group"
                            :aria-label="$t('_PanelHeight')"
                          >
                            <v-btn value="default" data-testid="snipped-panel-height-mode-default">{{ $t('_PanelHeightDefault') }}</v-btn>
                            <v-btn value="full" data-testid="snipped-panel-height-mode-full">{{ $t('_PanelHeightFull') }}</v-btn>
                            <v-btn value="custom" data-testid="snipped-panel-height-mode-custom">{{ $t('_PanelHeightCustom') }}</v-btn>
                          </v-btn-toggle>
                          <span class="snipped-control-hint" data-testid="snipped-panel-height-hint">{{ panelHeightHint }}</span>
                        </div>
                        <div class="fullstream-control-group" v-if="ConfigData.SnippedPanelHeightMode === 'custom'">
                          <label class="fullstream-control-label" for="snipped-panel-height-px">{{ $t('_PanelHeightPx') }}</label>
                          <v-text-field
                            v-model.number="ConfigData.SnippedPanelHeight"
                            :rules="[panelHeightRule]"
                            validate-on="input eager"
                            type="number"
                            :min="panelHeightMin"
                            :max="panelHeightMax"
                            step="1"
                            suffix="px"
                            variant="outlined"
                            density="comfortable"
                            hide-details="auto"
                            bg-color="white"
                            id="snipped-panel-height-px"
                            data-testid="snipped-panel-height-px"
                          ></v-text-field>
                        </div>

                        <!-- Send button (ปุ่มส่งข้อความในแชท) — style ล้อ Launcher · ลูกศร recolor ตาม variant -->
                        <div class="fullstream-control-group">
                          <label class="fullstream-control-label">{{ $t('_SendButtonStyle') }}</label>
                          <v-btn-toggle
                            v-model="ConfigData.SnippedSendButtonVariant"
                            mandatory
                            density="compact"
                            variant="outlined"
                            data-testid="snipped-sendbutton-variant"
                          >
                            <v-btn value="default">{{ $t('_VariantDefault') }}</v-btn>
                            <v-btn value="secondary">{{ $t('_VariantSecondary') }}</v-btn>
                            <v-btn value="outline">{{ $t('_VariantOutline') }}</v-btn>
                          </v-btn-toggle>
                          <span class="snipped-control-hint">{{ $t('_HintSendButtonVariant') }}</span>
                        </div>

                        <div class="fullstream-control-group">
                          <div class="fullstream-control-header mb-2">
                            <label class="fullstream-control-label mb-0" for="snipped-sendbutton-color">{{ $t('_SendButtonColor') }}</label>
                            <v-btn color="#CDD5F3" class="reset-btn fullstream-mini-reset" @click="setAsDefault('SnippedSendButtonColor')">
                              <img src="@/assets/Icons/new_reset_wrench.png" alt="reset_wrench" width="18" height="18" />
                              <v-tooltip activator="parent" location="top">{{ $t('_ResetSendButtonColor') }}</v-tooltip>
                            </v-btn>
                          </div>
                          <v-text-field
                            v-model="ConfigData.SnippedSendButtonColor"
                            :rules="[hexColorRule]"
                            placeholder="#RRGGBB"
                            variant="outlined"
                            density="comfortable"
                            hide-details="auto"
                            bg-color="white"
                            clearable
                            id="snipped-sendbutton-color"
                            data-testid="snipped-sendbutton-color"
                          >
                            <template #prepend-inner>
                              <v-menu :close-on-content-click="false" location="bottom start" offset="8">
                                <template #activator="{ props }">
                                  <span
                                    class="snipped-color-swatch snipped-color-swatch--clickable"
                                    :style="{ backgroundColor: swatchColor(ConfigData.SnippedSendButtonColor) }"
                                    v-bind="props"
                                  ></span>
                                </template>
                                <v-color-picker
                                  :model-value="ConfigData.SnippedSendButtonColor || '#FFFFFF'"
                                  @update:model-value="ConfigData.SnippedSendButtonColor = ($event || '').slice(0, 7)"
                                  mode="hex"
                                  hide-mode-switch
                                  show-swatches
                                  :swatches="swatches"
                                ></v-color-picker>
                              </v-menu>
                            </template>
                          </v-text-field>
                          <span class="snipped-control-hint">{{ $t('_HintUseThemeColorWhenEmpty') }}</span>
                        </div>

                        <div class="fullstream-control-group">
                          <label class="fullstream-control-label" for="snipped-disclaimer-text">{{ $t('_DisclaimerText') }}</label>
                          <v-textarea
                            v-model="ConfigData.SnippedDisclaimerText"
                            variant="outlined"
                            density="comfortable"
                            rows="3"
                            auto-grow
                            hide-details="auto"
                            bg-color="white"
                            id="snipped-disclaimer-text"
                            data-testid="snipped-disclaimer-text"
                          ></v-textarea>
                        </div>

                        <div class="fullstream-control-group">
                          <label class="fullstream-control-label" for="snipped-input-placeholder">{{ $t('_InputPlaceholder') }}</label>
                          <v-text-field
                            v-model="ConfigData.SnippedInputPlaceholder"
                            variant="outlined"
                            density="comfortable"
                            hide-details="auto"
                            bg-color="white"
                            id="snipped-input-placeholder"
                            data-testid="snipped-input-placeholder"
                          ></v-text-field>
                        </div>

                        <div class="fullstream-control-group">
                          <label class="fullstream-control-label" for="snipped-typing-text">{{ $t('_TypingText') }}</label>
                          <v-text-field
                            v-model="ConfigData.SnippedTypingText"
                            variant="outlined"
                            density="comfortable"
                            hide-details="auto"
                            bg-color="white"
                            id="snipped-typing-text"
                            data-testid="snipped-typing-text"
                          ></v-text-field>
                        </div>

                        <div class="fullstream-control-group">
                          <v-switch
                            v-model="ConfigData.SnippedShowModelTopicBar"
                            :label="$t('_ShowModelTopicBar')"
                            color="primary"
                            density="comfortable"
                            hide-details
                            inset
                            data-testid="snipped-show-modeltopicbar"
                          ></v-switch>
                        </div>
                        <div class="fullstream-control-group">
                          <v-switch
                            v-model="ConfigData.SnippedShowVersion"
                            :label="$t('_ShowVersion')"
                            color="primary"
                            density="comfortable"
                            hide-details
                            inset
                            data-testid="snipped-show-version"
                          ></v-switch>
                        </div>
                        <div class="fullstream-control-group mb-0">
                          <v-switch
                            v-model="ConfigData.SnippedShowCharCounter"
                            :label="$t('_ShowCharCounter')"
                            color="primary"
                            density="comfortable"
                            hide-details
                            inset
                            data-testid="snipped-show-charcounter"
                          ></v-switch>
                        </div>
                      </div>
                    </v-card>

                    <!-- ③ Launcher -->
                    <v-card style="box-shadow: none !important; background-color: #ffffff" class="mt-4">
                      <div class="d-flex align-center mb-3">
                        <img src="@/assets/Icons/new_color_paint_brush.png" alt="color_paint_brush" width="37" height="37" class="mr-2" />
                        <span class="font-weight-bold" style="font-size: 23px">{{ $t('_Launcher') }}</span>
                      </div>
                      <div class="style-div" style="height: auto !important; padding-bottom: 16px">
                        <div class="fullstream-control-group">
                          <label class="fullstream-control-label" for="snipped-launcher-shape">{{ $t('_Shape') }}</label>
                          <v-btn-toggle v-model="ConfigData.SnippedLauncherShape" mandatory density="compact" variant="outlined" id="snipped-launcher-shape" data-testid="snipped-launcher-shape">
                            <v-btn value="circle">{{ $t('_Circle') }}</v-btn>
                            <v-btn value="pill">{{ $t('_Pill') }}</v-btn>
                          </v-btn-toggle>
                        </div>

                        <div class="fullstream-control-group" v-if="ConfigData.SnippedLauncherShape === 'pill'">
                          <label class="fullstream-control-label" for="snipped-launcher-text">{{ $t('_Text') }}</label>
                          <v-text-field
                            v-model="ConfigData.SnippedLauncherText"
                            variant="outlined"
                            density="comfortable"
                            hide-details="auto"
                            bg-color="white"
                            id="snipped-launcher-text"
                            data-testid="snipped-launcher-text"
                          ></v-text-field>
                        </div>

                        <div class="fullstream-control-group" v-if="ConfigData.SnippedLauncherShape === 'pill' && ConfigData.SnippedLauncherVariant === 'default'">
                          <div class="fullstream-control-header mb-2">
                            <label class="fullstream-control-label mb-0" for="snipped-launcher-textcolor">{{ $t('_TextColor') }}</label>
                            <v-btn color="#CDD5F3" class="reset-btn fullstream-mini-reset" @click="setAsDefault('SnippedLauncherTextColor')">
                              <img src="@/assets/Icons/new_reset_wrench.png" alt="reset_wrench" width="18" height="18" />
                              <v-tooltip activator="parent" location="top">{{ $t('_ResetTextColor') }}</v-tooltip>
                            </v-btn>
                          </div>
                          <v-text-field
                            v-model="ConfigData.SnippedLauncherTextColor"
                            :rules="[hexColorRule]"
                            placeholder="#RRGGBB"
                            variant="outlined"
                            density="comfortable"
                            hide-details="auto"
                            bg-color="white"
                            clearable
                            id="snipped-launcher-textcolor"
                            data-testid="snipped-launcher-textcolor"
                          >
                            <template #prepend-inner>
                              <v-menu :close-on-content-click="false" location="bottom start" offset="8">
                                <template #activator="{ props }">
                                  <span
                                    class="snipped-color-swatch snipped-color-swatch--clickable"
                                    :style="{ backgroundColor: swatchColor(ConfigData.SnippedLauncherTextColor) }"
                                    v-bind="props"
                                  ></span>
                                </template>
                                <v-color-picker
                                  :model-value="ConfigData.SnippedLauncherTextColor || '#FFFFFF'"
                                  @update:model-value="ConfigData.SnippedLauncherTextColor = ($event || '').slice(0, 7)"
                                  mode="hex"
                                  hide-mode-switch
                                  show-swatches
                                  :swatches="swatches"
                                ></v-color-picker>
                              </v-menu>
                            </template>
                          </v-text-field>
                        </div>

                        <div class="fullstream-control-group">
                          <div class="fullstream-control-header mb-2">
                            <label class="fullstream-control-label mb-0" for="snipped-launcher-bgcolor">{{ $t('_BackgroundColor') }}</label>
                            <v-btn color="#CDD5F3" class="reset-btn fullstream-mini-reset" @click="setAsDefault('SnippedLauncherBgColor')">
                              <img src="@/assets/Icons/new_reset_wrench.png" alt="reset_wrench" width="18" height="18" />
                              <v-tooltip activator="parent" location="top">{{ $t('_ResetBackgroundColor') }}</v-tooltip>
                            </v-btn>
                          </div>
                          <v-text-field
                            v-model="ConfigData.SnippedLauncherBgColor"
                            :rules="[hexColorRule]"
                            :placeholder="$t('_PlaceholderHeaderColorHint')"
                            variant="outlined"
                            density="comfortable"
                            hide-details="auto"
                            bg-color="white"
                            clearable
                            id="snipped-launcher-bgcolor"
                            data-testid="snipped-launcher-bgcolor"
                          >
                            <template #prepend-inner>
                              <v-menu :close-on-content-click="false" location="bottom start" offset="8">
                                <template #activator="{ props }">
                                  <span
                                    class="snipped-color-swatch snipped-color-swatch--clickable"
                                    :style="{ backgroundColor: swatchColor(ConfigData.SnippedLauncherBgColor) }"
                                    v-bind="props"
                                  ></span>
                                </template>
                                <v-color-picker
                                  :model-value="ConfigData.SnippedLauncherBgColor || '#FFFFFF'"
                                  @update:model-value="ConfigData.SnippedLauncherBgColor = ($event || '').slice(0, 7)"
                                  mode="hex"
                                  hide-mode-switch
                                  show-swatches
                                  :swatches="swatches"
                                ></v-color-picker>
                              </v-menu>
                            </template>
                          </v-text-field>
                        </div>

                        <div class="fullstream-control-group">
                          <label class="fullstream-control-label" for="snipped-launcher-variant">{{ $t('_ButtonStyle') }}</label>
                          <v-btn-toggle v-model="ConfigData.SnippedLauncherVariant" mandatory density="compact" variant="outlined" id="snipped-launcher-variant" data-testid="snipped-launcher-variant">
                            <v-btn value="default">{{ $t('_Default') }}</v-btn>
                            <v-btn value="secondary">{{ $t('_Secondary') }}</v-btn>
                            <v-btn value="outline">{{ $t('_Outline') }}</v-btn>
                          </v-btn-toggle>
                        </div>

                        <!-- Launcher icon: mdi picker vs upload image (mode = IsImgSnippedLauncherIcon) -->
                        <div class="fullstream-control-group">
                          <div class="chatbot-icon-selector">
                            <div class="chatbot-icon-selector__header">
                              <div class="chatbot-icon-selector__preview">
                                <v-img v-if="ConfigData.IsImgSnippedLauncherIcon" :src="images.SnippedLauncherIcon" cover class="chatbot-icon-selector__image" />
                                <v-icon v-else size="24">{{ ConfigData.SnippedLauncherIcon || 'mdi-robot-outline' }}</v-icon>
                              </div>
                              <div class="chatbot-icon-selector__text">
                                <label for="launcher-icon-upload">{{ $t('_LauncherIcon') }}</label>
                                <span>{{ $t('_SelectIconOrUploadImage') }}</span>
                              </div>
                              <div class="chatbot-icon-selector__actions">
                                <v-btn color="#CDD5F3" class="reset-btn fullstream-mini-reset" @click="setAsDefault('SnippedLauncherIcon')" data-testid="snipped-launcher-icon-reset">
                                  <img src="@/assets/Icons/new_reset_wrench.png" alt="reset_wrench" width="18" height="18" />
                                  <v-tooltip activator="parent" location="top">{{ $t('_ResetLauncherIcon') }}</v-tooltip>
                                </v-btn>
                              </div>
                            </div>
                            <div class="chatbot-icon-selector__grid">
                              <button
                                v-for="item in selectableChatbotIcons"
                                :key="'launcher-' + item.icon"
                                type="button"
                                class="chatbot-icon-option"
                                :class="{ 'chatbot-icon-option--active': !ConfigData.IsImgSnippedLauncherIcon && ConfigData.SnippedLauncherIcon === item.icon }"
                                :data-testid="'snipped-launcher-icon-' + item.icon"
                                @click="selectSnippedLauncherIcon(item.icon)"
                              >
                                <v-icon size="22">{{ item.icon }}</v-icon>
                              </button>
                              <label class="chatbot-icon-option chatbot-icon-option--upload" for="launcher-icon-upload">
                                <v-icon size="22">mdi-image-plus-outline</v-icon>
                                <input
                                  type="file"
                                  id="launcher-icon-upload"
                                  name="launcher-icon"
                                  class="d-none"
                                  accept="image/*"
                                  data-testid="snipped-launcher-icon-upload"
                                  @change="inputSnippedLauncherIcon($event)"
                                />
                              </label>
                            </div>
                          </div>
                        </div>

                        <!-- ปุ่มแบบ circle มีแต่ไอคอน ปิดแล้วจะเหลือปุ่มเปล่า → ล็อกสวิตช์ไว้จนกว่าจะเป็น pill ที่มี Text -->
                        <div class="fullstream-control-group">
                          <v-switch
                            v-model="ConfigData.SnippedShowLauncherIcon"
                            :label="$t('_ShowLauncherIcon')"
                            color="primary"
                            density="comfortable"
                            hide-details
                            inset
                            :disabled="isSnippedLauncherIconLocked"
                            data-testid="snipped-show-launchericon"
                          ></v-switch>
                          <span v-if="isSnippedLauncherIconLocked" class="snipped-control-hint">{{ $t('_HintLauncherIconLockedCircle') }}</span>
                        </div>

                        <div class="fullstream-control-group">
                          <label class="fullstream-control-label" for="snipped-launcher-position">{{ $t('_Position') }}</label>
                          <v-select
                            v-model="ConfigData.SnippedLauncherPosition"
                            :items="launcherPositionOptions"
                            item-title="text"
                            item-value="value"
                            variant="outlined"
                            density="comfortable"
                            hide-details="auto"
                            bg-color="white"
                            id="snipped-launcher-position"
                            data-testid="snipped-launcher-position"
                          ></v-select>
                          <span style="font-size: 12px; color: #71717a; display: block; margin-top: 4px">{{ $t('_LauncherPositionHint') }}</span>
                        </div>

                        <v-row class="mt-0">
                          <v-col cols="6">
                            <div class="fullstream-control-group mb-0">
                              <label class="fullstream-control-label" for="snipped-launcher-offsetx">{{ $t('_OffsetX') }}</label>
                              <v-text-field
                                v-model.number="ConfigData.SnippedLauncherOffsetX"
                                :rules="[integerRule]"
                                type="number"
                                min="0"
                                suffix="px"
                                variant="outlined"
                                density="comfortable"
                                hide-details="auto"
                                bg-color="white"
                                id="snipped-launcher-offsetx"
                                data-testid="snipped-launcher-offsetx"
                              ></v-text-field>
                            </div>
                          </v-col>
                          <v-col cols="6">
                            <div class="fullstream-control-group mb-0">
                              <label class="fullstream-control-label" for="snipped-launcher-offsety">{{ $t('_OffsetY') }}</label>
                              <v-text-field
                                v-model.number="ConfigData.SnippedLauncherOffsetY"
                                :rules="[integerRule]"
                                type="number"
                                min="0"
                                suffix="px"
                                variant="outlined"
                                density="comfortable"
                                hide-details="auto"
                                bg-color="white"
                                id="snipped-launcher-offsety"
                                data-testid="snipped-launcher-offsety"
                              ></v-text-field>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </v-card>

                    <!-- ④ Greeting Bubble (teaser ข้างปุ่ม launcher) -->
                    <v-card style="box-shadow: none !important; background-color: #ffffff" class="mt-4">
                      <div class="d-flex align-center mb-3">
                        <img src="@/assets/Icons/new_color_paint_brush.png" alt="color_paint_brush" width="37" height="37" class="mr-2" />
                        <span class="font-weight-bold" style="font-size: 23px">{{ $t('_GreetingBubble') }}</span>
                      </div>
                      <div class="style-div" style="height: auto !important; padding-bottom: 16px">
                        <div class="fullstream-control-group">
                          <v-switch
                            v-model="ConfigData.SnippedTeaserEnabled"
                            :label="$t('_ShowGreetingBubble')"
                            color="primary"
                            density="comfortable"
                            hide-details
                            inset
                            data-testid="snipped-teaser-enabled"
                          ></v-switch>
                          <span style="font-size: 12px; color: #71717a; display: block; margin-top: 4px">{{ $t('_TeaserGreetingHint') }}</span>
                        </div>
                        <div class="fullstream-control-group" v-if="ConfigData.SnippedTeaserEnabled">
                          <div class="fullstream-control-header mb-2">
                            <label class="fullstream-control-label mb-0" for="snipped-teaser-bgcolor">{{ $t('_BubbleBackground') }}</label>
                            <v-btn color="#CDD5F3" class="reset-btn fullstream-mini-reset" @click="setAsDefault('SnippedTeaserBgColor')">
                              <img src="@/assets/Icons/new_reset_wrench.png" alt="reset_wrench" width="18" height="18" />
                              <v-tooltip activator="parent" location="top">{{ $t('_ResetBubbleBackground') }}</v-tooltip>
                            </v-btn>
                          </div>
                          <v-text-field
                            v-model="ConfigData.SnippedTeaserBgColor"
                            :rules="[hexColorRule]"
                            :placeholder="$t('_PlaceholderKeepCurrent')"
                            variant="outlined"
                            density="comfortable"
                            hide-details="auto"
                            bg-color="white"
                            clearable
                            id="snipped-teaser-bgcolor"
                            data-testid="snipped-teaser-bgcolor"
                          >
                            <template #prepend-inner>
                              <v-menu :close-on-content-click="false" location="bottom start" offset="8">
                                <template #activator="{ props }">
                                  <span
                                    class="snipped-color-swatch snipped-color-swatch--clickable"
                                    :style="{ backgroundColor: swatchColor(ConfigData.SnippedTeaserBgColor) }"
                                    v-bind="props"
                                  ></span>
                                </template>
                                <v-color-picker
                                  :model-value="ConfigData.SnippedTeaserBgColor || '#FFFFFF'"
                                  @update:model-value="ConfigData.SnippedTeaserBgColor = ($event || '').slice(0, 7)"
                                  mode="hex"
                                  hide-mode-switch
                                  show-swatches
                                  :swatches="swatches"
                                ></v-color-picker>
                              </v-menu>
                            </template>
                          </v-text-field>
                        </div>
                        <div class="fullstream-control-group mb-0" v-if="ConfigData.SnippedTeaserEnabled">
                          <div class="fullstream-control-header mb-2">
                            <label class="fullstream-control-label mb-0" for="snipped-teaser-textcolor">{{ $t('_BubbleText') }}</label>
                            <v-btn color="#CDD5F3" class="reset-btn fullstream-mini-reset" @click="setAsDefault('SnippedTeaserTextColor')">
                              <img src="@/assets/Icons/new_reset_wrench.png" alt="reset_wrench" width="18" height="18" />
                              <v-tooltip activator="parent" location="top">{{ $t('_ResetBubbleText') }}</v-tooltip>
                            </v-btn>
                          </div>
                          <v-text-field
                            v-model="ConfigData.SnippedTeaserTextColor"
                            :rules="[hexColorRule]"
                            :placeholder="$t('_PlaceholderKeepCurrent')"
                            variant="outlined"
                            density="comfortable"
                            hide-details="auto"
                            bg-color="white"
                            clearable
                            id="snipped-teaser-textcolor"
                            data-testid="snipped-teaser-textcolor"
                          >
                            <template #prepend-inner>
                              <v-menu :close-on-content-click="false" location="bottom start" offset="8">
                                <template #activator="{ props }">
                                  <span
                                    class="snipped-color-swatch snipped-color-swatch--clickable"
                                    :style="{ backgroundColor: swatchColor(ConfigData.SnippedTeaserTextColor) }"
                                    v-bind="props"
                                  ></span>
                                </template>
                                <v-color-picker
                                  :model-value="ConfigData.SnippedTeaserTextColor || '#FFFFFF'"
                                  @update:model-value="ConfigData.SnippedTeaserTextColor = ($event || '').slice(0, 7)"
                                  mode="hex"
                                  hide-mode-switch
                                  show-swatches
                                  :swatches="swatches"
                                ></v-color-picker>
                              </v-menu>
                            </template>
                          </v-text-field>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </div>

            <!-- Fullstream Tab -->
            <div v-show="activeTab === 'fullstream'">
              <v-col cols="12">
                <v-row class="mb-6">
                  <v-col cols="12" md="5">
                    <v-card style="box-shadow: none !important; background-color: #ffffff">
                      <div class="d-flex align-center mb-3">
                        <img src="@/assets/Icons/new_color_paint_brush.png" alt="color_paint_brush" width="37" height="37" />
                        <span class="font-weight-bold" style="font-size: 23px">{{ $t('_FullstreamText') }}</span>
                      </div>
                      <div class="style-div fullstream-style-div">
                        <v-card-title class="text-black px-0 mb-5" style="display: flex; justify-content: space-between">
                          <span style="font-weight: 600">{{ $t('_PreviewText') }}</span>
                          <v-btn color="#CDD5F3" class="reset-btn" @click="resetFullstreamPreview">
                            <img src="@/assets/Icons/new_reset_wrench.png" alt="reset_wrench" width="26" height="26" />
                            <v-tooltip activator="parent" location="top"> {{ $t('_ResetFullstreamDefaults') }} </v-tooltip>
                          </v-btn>
                        </v-card-title>

                        <div class="fullstream-control-group">
                          <label class="fullstream-control-label" for="fullstream-welcome-title-configtheme">{{ $t('_WelcomeTitle') }}</label>
                          <v-text-field
                            id="fullstream-welcome-title-configtheme"
                            v-model="fullstreamPreview.welcomeTitle"
                            variant="outlined"
                            density="comfortable"
                            maxlength="30"
                            counter
                            hide-details="auto"
                            bg-color="white"
                          ></v-text-field>
                        </div>

                        <div class="fullstream-control-group">
                          <label class="fullstream-control-label" for="fullstream-welcome-subtitle-configtheme">{{ $t('_WelcomeSubtitle') }}</label>
                          <v-textarea
                            id="fullstream-welcome-subtitle-configtheme"
                            v-model="fullstreamPreview.welcomeSubtitle"
                            variant="outlined"
                            density="comfortable"
                            rows="3"
                            auto-grow
                            maxlength="80"
                            counter
                            hide-details="auto"
                            bg-color="white"
                          ></v-textarea>
                        </div>

                        <div class="fullstream-control-group mb-0">
                          <label class="fullstream-control-label" for="fullstream-disclaimer-configtheme">{{ $t('_Disclaimer') }}</label>
                          <v-textarea
                            id="fullstream-disclaimer-configtheme"
                            v-model="fullstreamPreview.disclaimerText"
                            variant="outlined"
                            density="comfortable"
                            rows="4"
                            auto-grow
                            maxlength="60"
                            counter
                            hide-details="auto"
                            bg-color="white"
                          ></v-textarea>
                        </div>
                      </div>
                    </v-card>
                  </v-col>

                  <v-col cols="12" md="7">
                    <div class="d-flex align-center mb-3">
                      <img src="@/assets/Icons/new_color_content_view.png" alt="color_content_view" width="37" height="37" class="mr-2" />
                      <span class="font-weight-bold" style="font-size: 23px">{{ $t('_TextPreview') }}</span>
                    </div>
                    <v-card class="fullstream-preview-card fullstream-section-preview pa-4 pa-md-6">
                      <div class="fullstream-text-preview-card">
                        <div class="fullstream-text-preview-content">
                          <h2 class="fullstream-preview-title">{{ fullstreamPreview.welcomeTitle }}</h2>
                          <p class="fullstream-preview-subtitle">{{ fullstreamPreview.welcomeSubtitle }}</p>
                        </div>

                        <div class="fullstream-text-preview-footer">
                          <div class="fullstream-chat-preview-composer fullstream-chat-preview-composer--text-preview">
                            <span class="fullstream-chat-preview-placeholder">Ask anything...</span>
                            <div class="fullstream-chat-preview-actions">
                              <span class="fullstream-preview-counter">0 / 4000</span>
                              <div class="fullstream-chat-preview-send" :style="{ backgroundColor: ConfigData.FullstreamChatColorTheme }">
                                <v-icon size="16" color="white">mdi-arrow-up</v-icon>
                              </div>
                            </div>
                          </div>

                          <div class="fullstream-preview-disclaimer-box fullstream-preview-disclaimer-box--below-chat">
                            {{ fullstreamPreview.disclaimerText }}
                          </div>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="5">
                    <v-card style="box-shadow: none !important; background-color: #ffffff">
                      <div class="d-flex align-center mb-3">
                        <img src="@/assets/Icons/new_color_paint_brush.png" alt="color_paint_brush" width="37" height="37" />
                        <span class="font-weight-bold" style="font-size: 23px">{{ $t('_FullstreamChat') }}</span>
                      </div>
                      <div class="style-div fullstream-style-div fullstream-style-div--compact">
                        <div class="fullstream-control-header">
                          <label class="fullstream-control-label mb-0" for="cp-fullstreamfont-configtheme">{{ $t('_FontColor') }}</label>
                          <v-btn color="#CDD5F3" class="reset-btn fullstream-mini-reset" @click="setAsDefault('FullstreamTextColor')">
                            <img src="@/assets/Icons/new_reset_wrench.png" alt="reset_wrench" width="18" height="18" />
                            <v-tooltip activator="parent" location="top"> {{ $t('_ResetFontColor') }} </v-tooltip>
                          </v-btn>
                        </div>
                        <v-color-picker
                          id="cp-fullstreamfont-configtheme"
                          :key="'cp-fullstreamfont-' + colorPickerKey"
                          v-model="ConfigData.FullstreamNavbarTxtColorTheme"
                          mode="hex"
                          width="100%"
                          hide-mode-switch
                          show-swatches
                          :swatches="swatches"
                          class="mb-4"
                        ></v-color-picker>

                        <div class="fullstream-control-header">
                          <label class="fullstream-control-label mb-0" for="chatcolortheme-fullstream-configtheme">{{ $t('_ChatAccent') }}</label>
                          <v-btn color="#CDD5F3" class="reset-btn fullstream-mini-reset" @click="setAsDefault('FullstreamChatColor')">
                            <img src="@/assets/Icons/new_reset_wrench.png" alt="reset_wrench" width="18" height="18" />
                            <v-tooltip activator="parent" location="top"> {{ $t('_ResetChatAccent') }} </v-tooltip>
                          </v-btn>
                        </div>
                        <v-color-picker
                          id="chatcolortheme-fullstream-configtheme"
                          :key="'cp-fullstreamchat-' + colorPickerKey"
                          v-model="ConfigData.FullstreamChatColorTheme"
                          mode="hex"
                          width="100%"
                          hide-mode-switch
                          show-swatches
                          :swatches="swatches"
                          class="mb-4"
                        ></v-color-picker>

                        <div class="fullstream-control-header">
                          <label class="fullstream-control-label mb-0" for="cp-fullstreamicon-configtheme">{{ $t('_HeaderIcon') }}</label>
                          <v-btn color="#CDD5F3" class="reset-btn fullstream-mini-reset" @click="setAsDefault('FullstreamNavbarIconColor')">
                            <img src="@/assets/Icons/new_reset_wrench.png" alt="reset_wrench" width="18" height="18" />
                            <v-tooltip activator="parent" location="top"> {{ $t('_ResetHeaderIcon') }} </v-tooltip>
                          </v-btn>
                        </div>
                        <v-color-picker
                          id="cp-fullstreamicon-configtheme"
                          :key="'cp-fullstreamicon-' + colorPickerKey"
                          v-model="ConfigData.FullstreamNavbarIconColorTheme"
                          mode="hex"
                          width="100%"
                          hide-mode-switch
                          show-swatches
                          :swatches="swatches"
                          class="mb-4"
                        ></v-color-picker>

                        <div class="chatbot-icon-selector" :class="{ 'chatbot-icon-selector--icon-off': !ConfigData.isChatbotIconEnabled }">
                          <div class="chatbot-icon-selector__header">
                            <div class="chatbot-icon-selector__preview" :style="{ backgroundColor: '#ffffff', color: ConfigData.FullstreamChatColorTheme }">
                              <v-img v-if="ConfigData.isChatbotIconEnabled && ConfigData.isImgIconChat" :src="images.ChatbotIcon" cover class="chatbot-icon-selector__image" />
                              <v-icon v-else-if="ConfigData.isChatbotIconEnabled" size="24" :style="fullstreamHeaderIconPreviewStyle">{{ ConfigData.ChatbotIcon }}</v-icon>
                            </div>
                            <div class="chatbot-icon-selector__text">
                              <label for="switch-chatboticon-fullstream-configtheme">{{ $t('_ChatbotIcon') }}</label>
                              <span>{{ $t('_SelectIconOrUploadImage') }}</span>
                            </div>
                            <div class="chatbot-icon-selector__actions">
                              <div class="chatbot-icon-selector__toggle-wrap">
                                <span class="chatbot-icon-selector__toggle-label">{{ ConfigData.isChatbotIconEnabled ? $t('_IconOn') : $t('_IconOff') }}</span>
                                <v-tooltip location="top">
                                  <template v-slot:activator="{ props }">
                                    <v-switch
                                      id="switch-chatboticon-fullstream-configtheme"
                                      v-bind="props"
                                      v-model="ConfigData.isChatbotIconEnabled"
                                      color="#3859D0"
                                      density="compact"
                                      hide-details
                                      inset
                                      class="chatbot-icon-selector__toggle"
                                      @update:model-value="toggleChatbotIcon"
                                    ></v-switch>
                                  </template>
                                  {{ $t('_ShowHideChatbotIcon') }}
                                </v-tooltip>
                              </div>
                              <v-btn id="button-setdefault-chatboticon-fullstream-configtheme" color="#CDD5F3" class="reset-btn fullstream-mini-reset" @click="setAsDefault('FullstreamChatbotIcon')">
                                <img src="@/assets/Icons/new_reset_wrench.png" alt="reset_wrench" width="18" height="18" />
                                <v-tooltip activator="parent" location="top"> {{ $t('_ResetChatbotIcon') }} </v-tooltip>
                              </v-btn>
                            </div>
                          </div>
                          <div class="chatbot-icon-selector__grid">
                            <button
                              v-for="item in selectableChatbotIcons"
                              :key="item.icon"
                              type="button"
                              class="chatbot-icon-option"
                              :class="{ 'chatbot-icon-option--active': ConfigData.isChatbotIconEnabled && !ConfigData.isImgIconChat && ConfigData.ChatbotIcon === item.icon }"
                              :style="{ color: ConfigData.FullstreamNavbarIconColorTheme || ConfigData.FullstreamNavbarTxtColorTheme }"
                              @click="selectChatbotIcon(item.icon)"
                            >
                              <v-icon size="22">{{ item.icon }}</v-icon>
                            </button>
                            <label
                              class="chatbot-icon-option chatbot-icon-option--upload"
                              :class="{ 'chatbot-icon-option--active': ConfigData.isChatbotIconEnabled && ConfigData.isImgIconChat }"
                              for="img-upload"
                              :style="{ color: ConfigData.FullstreamNavbarIconColorTheme || ConfigData.FullstreamNavbarTxtColorTheme }"
                            >
                              <v-icon size="22">mdi-image-plus-outline</v-icon>
                              <input type="file" id="img-upload" name="avatar" class="d-none" accept="image/*" @change="inputChatIcon($event)" />
                            </label>
                          </div>
                        </div>
                      </div>
                    </v-card>
                  </v-col>

                  <v-col cols="12" md="7">
                    <div class="d-flex align-center mb-3">
                      <img src="@/assets/Icons/new_color_content_view.png" alt="color_content_view" width="37" height="37" class="mr-2" />
                      <span class="font-weight-bold" style="font-size: 23px">{{ $t('_ChatPreview') }}</span>
                    </div>
                    <v-card class="fullstream-preview-card fullstream-section-preview pa-4 pa-md-6">
                      <div class="fullstream-chat-preview-shell">
                        <div class="fullstream-chat-preview-thread">
                          <div class="fullstream-chat-preview-row">
                            <div class="fullstream-chat-preview-avatar" :style="{ backgroundColor: '#ffffff', color: ConfigData.FullstreamChatColorTheme }">
                              <v-img v-if="ConfigData.isChatbotIconEnabled && ConfigData.isImgIconChat" :src="images.ChatbotIcon" cover class="fullstream-chat-preview-avatar-image" />
                              <v-icon v-else-if="ConfigData.isChatbotIconEnabled" size="18" :style="fullstreamHeaderIconPreviewStyle">{{ ConfigData.ChatbotIcon }}</v-icon>
                            </div>
                            <div class="fullstream-chat-preview-bubble fullstream-chat-preview-bubble--bot">Ready to assist with product questions and support.</div>
                          </div>

                          <div class="fullstream-chat-preview-row fullstream-chat-preview-row--user">
                            <div
                              class="fullstream-chat-preview-bubble fullstream-chat-preview-bubble--user"
                              :style="{ backgroundColor: ConfigData.FullstreamChatColorTheme, color: ConfigData.FullstreamNavbarTxtColorTheme }"
                            >
                              Show me the new Fullstream greeting.
                            </div>
                          </div>
                        </div>

                        <div class="fullstream-chat-preview-composer">
                          <span class="fullstream-chat-preview-placeholder">Ask anything...</span>
                          <div class="fullstream-chat-preview-actions">
                            <span class="fullstream-preview-counter">0 / 4000</span>
                            <div class="fullstream-chat-preview-send" :style="{ backgroundColor: ConfigData.FullstreamChatColorTheme }">
                              <v-icon size="16" color="white">mdi-arrow-up</v-icon>
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-card>

                    <div class="d-flex align-center mb-3 fullstream-preview-offset fullstream-preview-offset--chat-accent">
                      <img src="@/assets/Icons/new_color_content_view.png" alt="color_content_view" width="37" height="37" class="mr-2" />
                      <span class="font-weight-bold" style="font-size: 23px">{{ $t('_ChatAccentPreview') }}</span>
                    </div>
                    <v-card class="fullstream-preview-card fullstream-section-preview pa-4 pa-md-6">
                      <div class="fullstream-chat-preview-shell">
                        <div class="fullstream-chat-preview-thread">
                          <div class="fullstream-chat-preview-row">
                            <div class="fullstream-chat-preview-avatar" :style="{ backgroundColor: '#ffffff', color: ConfigData.FullstreamChatColorTheme }">
                              <v-img v-if="ConfigData.isChatbotIconEnabled && ConfigData.isImgIconChat" :src="images.ChatbotIcon" cover class="fullstream-chat-preview-avatar-image" />
                              <v-icon v-else-if="ConfigData.isChatbotIconEnabled" size="18" :style="fullstreamHeaderIconPreviewStyle">{{ ConfigData.ChatbotIcon }}</v-icon>
                            </div>
                            <div class="fullstream-chat-preview-bubble fullstream-chat-preview-bubble--bot">Ready to assist with product questions and support.</div>
                          </div>

                          <div class="fullstream-chat-preview-row fullstream-chat-preview-row--user">
                            <div
                              class="fullstream-chat-preview-bubble fullstream-chat-preview-bubble--user"
                              :style="{ backgroundColor: ConfigData.FullstreamChatColorTheme, color: ConfigData.FullstreamNavbarTxtColorTheme }"
                            >
                              Show me the new Fullstream greeting.
                            </div>
                          </div>
                        </div>

                        <div class="fullstream-chat-preview-composer">
                          <span class="fullstream-chat-preview-placeholder">Ask anything...</span>
                          <div class="fullstream-chat-preview-actions">
                            <span class="fullstream-preview-counter">0 / 4000</span>
                            <div class="fullstream-chat-preview-send" :style="{ backgroundColor: ConfigData.FullstreamChatColorTheme }">
                              <v-icon size="16" color="white">mdi-arrow-up</v-icon>
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-card>

                    <div class="d-flex align-center mb-3 fullstream-preview-offset fullstream-preview-offset--header-icon">
                      <img src="@/assets/Icons/new_color_content_view.png" alt="color_content_view" width="37" height="37" class="mr-2" />
                      <span class="font-weight-bold" style="font-size: 23px">{{ $t('_HeaderIconPreview') }}</span>
                    </div>
                    <v-card class="fullstream-preview-card fullstream-section-preview pa-4 pa-md-6">
                      <div class="fullstream-chat-preview-shell">
                        <div class="fullstream-chat-preview-thread">
                          <div class="fullstream-chat-preview-row">
                            <div class="fullstream-chat-preview-avatar" :style="{ backgroundColor: '#ffffff', color: ConfigData.FullstreamChatColorTheme }">
                              <v-img v-if="ConfigData.isChatbotIconEnabled && ConfigData.isImgIconChat" :src="images.ChatbotIcon" cover class="fullstream-chat-preview-avatar-image" />
                              <v-icon v-else-if="ConfigData.isChatbotIconEnabled" size="18" :style="fullstreamHeaderIconPreviewStyle">{{ ConfigData.ChatbotIcon }}</v-icon>
                            </div>
                            <div class="fullstream-chat-preview-bubble fullstream-chat-preview-bubble--bot">Ready to assist with product questions and support.</div>
                          </div>

                          <div class="fullstream-chat-preview-row fullstream-chat-preview-row--user">
                            <div
                              class="fullstream-chat-preview-bubble fullstream-chat-preview-bubble--user"
                              :style="{ backgroundColor: ConfigData.FullstreamChatColorTheme, color: ConfigData.FullstreamNavbarTxtColorTheme }"
                            >
                              Show me the new Fullstream greeting.
                            </div>
                          </div>
                        </div>

                        <div class="fullstream-chat-preview-composer">
                          <span class="fullstream-chat-preview-placeholder">Ask anything...</span>
                          <div class="fullstream-chat-preview-actions">
                            <span class="fullstream-preview-counter">0 / 4000</span>
                            <div class="fullstream-chat-preview-send" :style="{ backgroundColor: ConfigData.FullstreamChatColorTheme }">
                              <v-icon size="16" color="white">mdi-arrow-up</v-icon>
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </div>
          </div>
        </v-flex>
      </v-card>
      <v-overlay :value="dialog">
        <v-dialog v-model="dialog" persistent width="300">
          <v-card color="#1976D2" dark>
            <v-card-text class="white--text">
              {{ $t('loadingpleasewait') }}
              <v-progress-linear indeterminate color="#FAA91B" class="mb-0"></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-overlay>

      <!-- default dialog -->
      <v-dialog v-model="showDefaultDialog" max-width="570">
        <v-card class="dialog-card">
          <v-card-title class="card-dialog-title py-4 px-5" style="background: linear-gradient(100deg, #e7ebff 0%, #ffffff 100%)">
            <span class="font-weight-bold" style="color: #001763 !important">{{ $t('confirmToSetDefault') }}</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pt-6 pb-4 px-4 body-text" style="font-weight: 600"> {{ $t('infoconfirmToSetDefault') }} </v-card-text>
          <hr style="border: none; border-top: 1px solid #c9c9c9" />
          <v-card-actions class="px-6 pb-3 pt-3 pl-8 justify-end" style="gap: 12px">
            <button type="button" class="cancel-btn" @click="closeDefaultDialog" :disabled="deleting">{{ $t('cancel') }}</button>
            <v-btn class="delete-confirm-btn" :loading="deleting" @click="setDefault(item)">
              <p style="color: #ffffff; font-weight: 500">{{ $t('confirm') }}</p>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- warning dialog -->
      <v-dialog v-model="showWarningDialog" max-width="570">
        <v-card class="dialog-card">
          <v-card-title class="card-dialog-title py-4 px-5" style="background: linear-gradient(100deg, #fff2f2 0%, #ffffff 100%)">
            <span class="font-weight-bold" style="color: #c30000 !important">{{ warningTitle }}</span>
            <v-icon v-show="showButton" size="30" class="cursor-pointer float-end" @click="closeWarningDialog" style="color: black"> mdi-close </v-icon>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pt-6 pb-4 px-4 body-text" style="font-weight: 500">
            {{ warningMessage }}
          </v-card-text>
          <hr style="border: none; border-top: 1px solid #c9c9c9" />
          <v-card-actions v-show="showButton" class="px-6 pb-3 pt-3 pl-8 justify-end" style="gap: 12px">
            <button type="button" class="warning-btn" @click="closeWarningDialog" :disabled="deleting">{{ $t('ok') }}</button>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
import DragDropFile from '@/components/DragDropFile.vue';
import LoginlogoImg from '@/assets/Group 141.png';
import navlogoImg from '@/assets/images/logo-removebg-preview@3x.png';
import navBGImg from '@/assets/images/gradient-abstract-style-wireframe-background 1.png';
import subNavBGImg from '@/assets/images/Rectangle 51.png';
import LoginStyle from '@/components/LoginStyle.vue';
import ServiceThemePreview from '@/components/ServiceThemePreview.vue';
import SnippedPreview from '@/components/SnippedPreview.vue';

const DEFAULT_SNIPPED_LOGO_URL = 'https://stg-fusionchatbots.azurewebsites.net/Snippet/chatframework-logo-white.png';

const FULLSTREAM_PREVIEW_DEFAULTS = {
  welcomeTitle: 'Welcome to Chat Framework',
  welcomeSubtitle: 'How can I help you today?',
  disclaimerText: 'AI can make mistakes. Please double-check responses.',
};

const FULLSTREAM_COLOR_DEFAULTS = {
  headerBackground: '#FFFFFF',
  headerText: '#FFFFFF',
  headerIcon: '#737277',
  chatAccent: '#737277',
};

const SNIPPED_PANEL_HEIGHT_MIN = 300;
const SNIPPED_PANEL_HEIGHT_MAX = 1000;
const SNIPPED_PANEL_HEIGHT_MODES = ['default', 'full', 'custom'];

const THEME_DEFAULTS = {
  chatbotName: 'Chatbot',
  chatbotIcon: 'mdi-robot-outline',
  fontColorTitle: '#FFFFFF',
  chatColorTheme: '#737277',
  navbarBtnColorTheme: '#FFFFFF',
  navbarTxtColorTheme: '#2596be',
  snippedColorThemeChat: '#FFA41E',
  snippedIcon: 'mdi-robot-outline',
  snippedIconColor: '#000000',
  snippedHeaderColorTheme: '#cf3d1e',
  snippedFontColorTheme: '#000000',
  // R2 — bot bubble uses the same 10%/20% alpha treatment as the user bubble, so a mid grey
  // reads as the familiar light-grey bubble; a near-white default would wash out at 10%.
  snippedBotBubbleColor: '#71717A',
  snippedBotFontColor: '#71717A',
  snippedSendButtonColor: '',
  snippedSendButtonVariant: 'default',
  chatPanelHeaderColorTheme: '#737277',
  chatPanelFontColorTheme: '#FFFFFF',
  fullstreamNavbarBtnColorTheme: FULLSTREAM_COLOR_DEFAULTS.headerBackground,
  fullstreamNavbarTxtColorTheme: FULLSTREAM_COLOR_DEFAULTS.headerText,
  fullstreamNavbarIconColorTheme: FULLSTREAM_COLOR_DEFAULTS.headerIcon,
  fullstreamChatColorTheme: FULLSTREAM_COLOR_DEFAULTS.chatAccent,
};

export default {
  components: { DragDropFile, LoginStyle, ServiceThemePreview, SnippedPreview },
  inject: [
    'flagNav',
    'getIMG',
    'getStartUpImage',
    'configColor',
    'LoginLogo',
    'IconChat',
    'NavbarIcon',
    'NavbarBackGround',
    'SubNavbarBackGround',
    'ChatbotName',
    'ChatbotIcon',
    'FontColorTitle',
    'colorThemeChat',
    'NavbarBtnColorTheme',
    'NavbarTxtColorTheme',
    'SnippedIcon',
    'SnippedIconColor',
  ],
  name: 'ConfigTheme',
  data: () => ({
    showDefaultDialog: false,
    showWarningDialog: false,
    showSuccess: false,
    SuccessMessage: '',
    warningTitle: '',
    warningMessage: '',
    showButton: true,
    activeTab: 'login',
    colorPickerKey: 0,
    resetLogo: false,
    resetHeaderLogo: false,
    resetNavBg: false,
    resetTitleBg: false,
    resetSnippedLogo: false,
    snippedlogo: DEFAULT_SNIPPED_LOGO_URL,
    date: new Date().toISOString().substr(0, 10),
    menu: false,
    dialog: false,
    today: null,
    images: {
      Loginlogo: LoginlogoImg,
      navlogo: navlogoImg,
      navBG: navBGImg,
      subNavBG: subNavBGImg,
      ChatbotIcon: null,
      SnippedIcon: null,
      SnippedLauncherIcon: null,
      snippedlogo: DEFAULT_SNIPPED_LOGO_URL,
    },
    panel: 0,
    itemsIcon: [
      { icon: 'mdi-robot-outline' },
      { icon: 'mdi-face-agent' },
      { icon: 'mdi-face-man-shimmer' },
      { icon: 'mdi-face-woman-shimmer' },
      { icon: 'mdi-account-circle-outline' },
      { icon: 'mdi-creation-outline' },

      { icon: '', title: 'More' },
    ],
    ConfigData: {
      ChatbotName: THEME_DEFAULTS.chatbotName,
      ChatbotIcon: THEME_DEFAULTS.chatbotIcon,
      FontColorTitle: THEME_DEFAULTS.fontColorTitle,
      chatColorTheme: THEME_DEFAULTS.chatColorTheme,
      NavbarBtnColorTheme: THEME_DEFAULTS.navbarBtnColorTheme,
      NavbarTxtColorTheme: THEME_DEFAULTS.navbarTxtColorTheme,
      FullstreamNavbarBtnColorTheme: THEME_DEFAULTS.fullstreamNavbarBtnColorTheme,
      FullstreamNavbarTxtColorTheme: THEME_DEFAULTS.fullstreamNavbarTxtColorTheme,
      FullstreamNavbarIconColorTheme: THEME_DEFAULTS.fullstreamNavbarIconColorTheme,
      FullstreamChatColorTheme: THEME_DEFAULTS.fullstreamChatColorTheme,
      SnippedHeaderColorTheme: THEME_DEFAULTS.snippedHeaderColorTheme,
      SnippedFontColorTheme: THEME_DEFAULTS.snippedFontColorTheme,
      SnippedIcon: THEME_DEFAULTS.snippedIcon,
      SnippedIconColor: THEME_DEFAULTS.snippedIconColor,
      ChatPanelHeaderColorTheme: THEME_DEFAULTS.chatPanelHeaderColorTheme,
      ChatPanelFontColorTheme: THEME_DEFAULTS.chatPanelFontColorTheme,

      isChatbotIconEnabled: true,
      isImgIconChat: false,
      ChatIcon: null,
      LoginLogo: null,
      navlogo: null,
      navBG: null,
      subNavBG: null,
      snippedColorThemeChat: THEME_DEFAULTS.snippedColorThemeChat,
      snippedlogo: null,

      // ── S1-P1: 20 Snippet widget fields (Snipped* keys, mirror API) ──
      // ① Launcher
      SnippedLauncherShape: 'circle',
      SnippedLauncherVariant: 'default',
      SnippedLauncherText: '',
      SnippedLauncherTextColor: '#FFFFFF',
      SnippedLauncherBgColor: '',
      SnippedLauncherIcon: '',
      IsImgSnippedLauncherIcon: false,
      SnippedLauncherPosition: 'bottom-right',
      SnippedLauncherOffsetX: null,
      SnippedLauncherOffsetY: null,
      // ② Teaser
      SnippedTeaserEnabled: false,
      SnippedTeaserBgColor: '',
      SnippedTeaserTextColor: '',
      // ③ Panel
      SnippedHeaderSubtitle: '',
      SnippedDisclaimerText: '',
      SnippedPanelBorderColor: '',
      SnippedInputPlaceholder: '',
      SnippedTypingText: '',
      // ④ Toggles
      SnippedShowBotName: false,
      SnippedShowModelTopicBar: true,

      // ── R2: 9 snippet display settings ──
      SnippedBotBubbleColor: THEME_DEFAULTS.snippedBotBubbleColor,
      SnippedBotFontColor: THEME_DEFAULTS.snippedBotFontColor,
      SnippedSendButtonColor: THEME_DEFAULTS.snippedSendButtonColor,
      SnippedSendButtonVariant: THEME_DEFAULTS.snippedSendButtonVariant,
      SnippedShowHeaderSubtitle: true,
      SnippedShowVersion: true,
      SnippedShowCharCounter: true,
      SnippedShowSnippedIcon: true,
      SnippedShowLauncherIcon: true,
      SnippedPanelHeightMode: 'default',
      SnippedPanelHeight: null,
    },
    panelHeightMin: SNIPPED_PANEL_HEIGHT_MIN,
    panelHeightMax: SNIPPED_PANEL_HEIGHT_MAX,
    swatches: [
      ['#FF0000', '#AA0000'],
      ['#FF8800', '#AF5800'],
      // ['#FFFF00', '#AAAA00'],
      ['#00FF00', '#00AA00'],
      ['#00FFFF', '#00AAAA'],
      ['#0000FF', '#0000AA'],
    ],
    files: null,
    listMessage: [
      {
        messageUser: '👋 Welcome! You’re now chatting with your AI-powered assistant.',
        messageBot: '👋 Hello!',
        status_Process: 'END',
      },
      {
        messageUser: 'Nice to meet you too! 😊 \nHow can I help you today?',
        messageBot: 'Nice to meet you!',
        status_Process: 'END',
      },
    ],
    fullstreamPreview: { ...FULLSTREAM_PREVIEW_DEFAULTS },
  }),
  computed: {
    loginLogoC() {
      return this.images.Loginlogo;
    },
    iconChat() {
      return this.IconChat;
    },
    NavbarIconC() {
      return this.NavbarIcon;
    },
    NavbarBackGroundC() {
      return this.NavbarBackGround;
    },
    subNavbarBackGroundC() {
      return this.SubNavbarBackGround;
    },
    chatbotNameC() {
      return this.ChatbotName;
    },
    chatbotIconC() {
      return this.ChatbotIcon;
    },
    selectableChatbotIcons() {
      return this.itemsIcon.filter((item) => item.icon);
    },
    fontColorTitleC() {
      return this.FontColorTitle;
    },
    ColorThemeChatC() {
      return this.colorThemeChat;
    },
    navbarBtnColorTheme() {
      return this.NavbarBtnColorTheme;
    },
    navbarTxtColorTheme() {
      return this.NavbarTxtColorTheme;
    },
    fullstreamHeaderPreviewBarStyle() {
      return {
        backgroundColor: this.ConfigData.FullstreamNavbarBtnColorTheme,
        color: this.ConfigData.FullstreamNavbarTxtColorTheme,
      };
    },
    fullstreamHeaderPreviewChipStyle() {
      return {
        borderColor: this.ConfigData.FullstreamNavbarTxtColorTheme,
        color: this.ConfigData.FullstreamNavbarTxtColorTheme,
      };
    },
    fullstreamHeaderIconPreviewStyle() {
      return {
        color: this.ConfigData.FullstreamNavbarIconColorTheme || this.ConfigData.FullstreamNavbarTxtColorTheme,
      };
    },
    hasSnippedIconFile() {
      return this.isFileValue(this.ConfigData.SnippedIcon);
    },
    isSnippedIconEnabled() {
      return typeof this.ConfigData.SnippedIcon === 'string' ? this.ConfigData.SnippedIcon.trim() !== '' : this.hasSnippedIconFile;
    },
    shouldUseSnippedIconImage() {
      const currentValue = this.hasSnippedIconFile ? this.images.SnippedIcon : this.ConfigData.SnippedIcon;
      return this.isUrlLikeIcon(currentValue);
    },
    snippedIconPreviewSource() {
      if (!this.isSnippedIconEnabled) {
        return '';
      }

      if (this.hasSnippedIconFile) {
        return this.images.SnippedIcon || '';
      }

      return this.shouldUseSnippedIconImage ? this.ConfigData.SnippedIcon : '';
    },
    snippedPreviewIconValue() {
      return this.hasSnippedIconFile ? this.snippedIconPreviewSource : this.ConfigData.SnippedIcon;
    },
    snippedIconPreviewStyle() {
      return {
        color: this.ConfigData.SnippedIconColor || THEME_DEFAULTS.snippedIconColor,
      };
    },
    launcherPositionOptions() {
      return [
        { text: this.$t('_BottomRight'), value: 'bottom-right' },
        { text: this.$t('_BottomLeft'), value: 'bottom-left' },
      ];
    },
    // Launcher icon value passed to preview: blob/url string when in image mode, else mdi name.
    snippedLauncherPreviewIconValue() {
      if (this.ConfigData.IsImgSnippedLauncherIcon) {
        return this.images.SnippedLauncherIcon || '';
      }
      return typeof this.ConfigData.SnippedLauncherIcon === 'string' ? this.ConfigData.SnippedLauncherIcon : '';
    },
    // Full prop set for <SnippedPreview> (PascalCase Snipped* — mirror API/T6 props). Booleans as real booleans.
    snippedPreviewProps() {
      return {
        SnippedLogo: this.images.snippedlogo,
        SnippedColorThemeChat: this.ConfigData.snippedColorThemeChat,
        SnippedIcon: this.snippedPreviewIconValue,
        SnippedIconColor: this.ConfigData.SnippedIconColor,
        SnippedHeaderColorTheme: this.ConfigData.SnippedHeaderColorTheme,
        SnippedFontColorTheme: this.ConfigData.SnippedFontColorTheme,
        SnippedLauncherShape: this.ConfigData.SnippedLauncherShape,
        SnippedLauncherVariant: this.ConfigData.SnippedLauncherVariant,
        SnippedLauncherText: this.ConfigData.SnippedLauncherText,
        SnippedLauncherTextColor: this.ConfigData.SnippedLauncherTextColor,
        SnippedLauncherBgColor: this.ConfigData.SnippedLauncherBgColor,
        SnippedLauncherIcon: this.snippedLauncherPreviewIconValue,
        IsImgSnippedLauncherIcon: this.ConfigData.IsImgSnippedLauncherIcon === true,
        SnippedLauncherPosition: this.ConfigData.SnippedLauncherPosition,
        SnippedLauncherOffsetX: this.ConfigData.SnippedLauncherOffsetX,
        SnippedLauncherOffsetY: this.ConfigData.SnippedLauncherOffsetY,
        SnippedTeaserEnabled: this.ConfigData.SnippedTeaserEnabled === true,
        SnippedTeaserBgColor: this.ConfigData.SnippedTeaserBgColor,
        SnippedTeaserTextColor: this.ConfigData.SnippedTeaserTextColor,
        SnippedHeaderSubtitle: this.ConfigData.SnippedHeaderSubtitle,
        SnippedDisclaimerText: this.ConfigData.SnippedDisclaimerText,
        SnippedPanelBorderColor: this.ConfigData.SnippedPanelBorderColor,
        SnippedInputPlaceholder: this.ConfigData.SnippedInputPlaceholder,
        SnippedTypingText: this.ConfigData.SnippedTypingText,
        SnippedShowBotName: this.ConfigData.SnippedShowBotName === true,
        SnippedShowModelTopicBar: this.ConfigData.SnippedShowModelTopicBar !== false,
        botName: this.ConfigData.ChatbotName,
        // R2 — null/undefined means "never set" and renders as shown, so compare against false.
        SnippedBotBubbleColor: this.ConfigData.SnippedBotBubbleColor,
        SnippedBotFontColor: this.ConfigData.SnippedBotFontColor,
        SnippedSendButtonColor: this.ConfigData.SnippedSendButtonColor,
        SnippedSendButtonVariant: this.ConfigData.SnippedSendButtonVariant,
        SnippedShowHeaderSubtitle: this.ConfigData.SnippedShowHeaderSubtitle !== false,
        SnippedShowVersion: this.ConfigData.SnippedShowVersion !== false,
        SnippedShowCharCounter: this.ConfigData.SnippedShowCharCounter !== false,
        SnippedShowSnippedIcon: this.ConfigData.SnippedShowSnippedIcon !== false,
        SnippedShowLauncherIcon: this.ConfigData.SnippedShowLauncherIcon !== false,
        SnippedPanelHeightMode: this.ConfigData.SnippedPanelHeightMode,
        SnippedPanelHeight: this.ConfigData.SnippedPanelHeight,
      };
    },
    panelHeightHint() {
      const keys = { default: '_PanelHeightHintDefault', full: '_PanelHeightHintFull', custom: '_PanelHeightHintCustom' };
      return this.$t(keys[this.ConfigData.SnippedPanelHeightMode] || keys.default);
    },
    // Client-side validation for the new Snippet fields → gates Save (same predicate as button disabled).
    // ปุ่ม launcher แบบวงกลมมีแต่ไอคอน ปิดแล้วเหลือวงกลมเปล่า → ล็อกสวิตช์ให้เปิดเสมอ
    // ยึด Shape ที่ผู้ใช้เลือกล้วน ๆ (ห้ามผูกกับ Launcher Text ไม่งั้นสลับเป็น pill แล้วสวิตช์ยังล็อกค้าง)
    isSnippedLauncherIconLocked() {
      return this.ConfigData.SnippedLauncherShape !== 'pill';
    },
    hasSnippedValidationError() {
      const colors = [
        this.ConfigData.SnippedLauncherTextColor,
        this.ConfigData.SnippedLauncherBgColor,
        this.ConfigData.SnippedTeaserBgColor,
        this.ConfigData.SnippedTeaserTextColor,
        this.ConfigData.SnippedPanelBorderColor,
        this.ConfigData.SnippedBotBubbleColor,
        this.ConfigData.SnippedBotFontColor,
        this.ConfigData.SnippedSendButtonColor,
      ];
      const colorInvalid = colors.some((c) => !this.isSnippedColorValid(c));
      const offsets = [this.ConfigData.SnippedLauncherOffsetX, this.ConfigData.SnippedLauncherOffsetY];
      const offsetInvalid = offsets.some((o) => !this.isSnippedOffsetValid(o));
      const panelHeightInvalid = !this.isSnippedPanelHeightValid(this.ConfigData.SnippedPanelHeightMode, this.ConfigData.SnippedPanelHeight);
      return colorInvalid || offsetInvalid || panelHeightInvalid;
    },
  },
  watch: {
    // เข้าโหมดวงกลมเมื่อไหร่ต้องบังคับ Show Launcher Icon = true (สวิตช์ถูก disable ผู้ใช้เปิดเองไม่ได้)
    // immediate ครอบเคสที่หน้าเปิดมาเป็นวงกลมตั้งแต่แรก หรือ config เก่าที่บันทึก false ไว้
    isSnippedLauncherIconLocked: {
      immediate: true,
      handler(locked) {
        if (locked && this.ConfigData.SnippedShowLauncherIcon !== true) {
          this.ConfigData.SnippedShowLauncherIcon = true;
        }
      },
    },
    loginLogoC(newValue) {
      this.images.Loginlogo = `${newValue}`;
    },
    iconChat(newValue) {
      this.images.IconChat = `${newValue}`;
    },
    NavbarIconC(newValue) {
      this.images.NavbarIcon = `${newValue}`;
    },
    NavbarBackGroundC(newValue) {
      this.images.NavbarBackGround = `'${newValue}'`;
    },
    subNavbarBackGroundC(newValue) {
      this.images.SubNavbarBackGround = `${newValue}`;
    },
    chatbotNameC(newValue) {
      this.ConfigData.ChatbotName = `${newValue}`;
    },
    chatbotIconC(newValue) {
      const hasIcon = newValue != null && newValue !== '';
      this.ConfigData.isChatbotIconEnabled = hasIcon;
      this.ConfigData.ChatbotIcon = hasIcon ? `${newValue}` : null;
    },
    fontColorTitleC(newValue) {
      this.ConfigData.FontColorTitle = `#${newValue}`;
    },
    ColorThemeChatC(newValue) {
      this.ConfigData.colorThemeChat = `#${newValue}`;
    },
    navbarBtnColorTheme(newValue) {
      this.ConfigData.NavbarBtnColorTheme = `#${newValue}`;
    },
    navbarTxtColorTheme(newValue) {
      this.ConfigData.NavbarTxtColorTheme = `#${newValue}`;
    },
    resetLogo(val) {
      if (val) {
        this.$nextTick(() => {
          this.resetLogo = false;
        });
      }
    },
    resetHeaderLogo(val) {
      if (val) {
        this.$nextTick(() => {
          this.resetHeaderLogo = false;
        });
      }
    },
    resetNavBg(val) {
      if (val) {
        this.$nextTick(() => {
          this.resetNavBg = false;
        });
      }
    },
    resetTitleBg(val) {
      if (val) {
        this.$nextTick(() => {
          this.resetTitleBg = false;
        });
      }
    },
    resetSnippedLogo(val) {
      if (val) {
        this.$nextTick(() => {
          this.resetSnippedLogo = false;
        });
      }
    },
  },

  mounted() {
    this.GetDate();
    this.Get();
  },
  beforeUnmount() {
    if (this._chatIconBlobPreviewUrl) {
      URL.revokeObjectURL(this._chatIconBlobPreviewUrl);
      this._chatIconBlobPreviewUrl = null;
    }
    if (this._snippedIconBlobPreviewUrl) {
      URL.revokeObjectURL(this._snippedIconBlobPreviewUrl);
      this._snippedIconBlobPreviewUrl = null;
    }
    if (this._snippedLauncherIconBlobPreviewUrl) {
      URL.revokeObjectURL(this._snippedLauncherIconBlobPreviewUrl);
      this._snippedLauncherIconBlobPreviewUrl = null;
    }
  },
  methods: {
    openDefaultDialog() {
      this.showDefaultDialog = true;
    },
    closeDefaultDialog() {
      this.showDefaultDialog = false;
    },
    openWarningDialog(title, message, show = true, sec = 3000) {
      this.warningTitle = title;
      this.warningMessage = message;
      this.showWarningDialog = true;
      this.showButton = show;
      if (!show) {
        setTimeout(() => {
          this.closeWarningDialog();
        }, sec);
      }
    },
    closeWarningDialog() {
      this.showWarningDialog = false;
      this.warningTitle = '';
      this.warningMessage = '';
      // Clear file input if exists
      const fileInput = document.getElementById('img-upload');
      if (fileInput) {
        fileInput.value = '';
      }

      // Clear any DragDropFile component inputs
      const dragDropInputs = document.querySelectorAll('input[type="file"]');
      dragDropInputs.forEach((input) => {
        input.value = '';
      });
    },
    formatThemeColor(value, fallbackColor) {
      if (!value) {
        return fallbackColor;
      }

      const colorValue = String(value);
      return colorValue.startsWith('#') ? colorValue : `#${colorValue}`;
    },
    isUrlLikeIcon(value) {
      if (typeof value !== 'string') {
        return false;
      }

      const normalizedValue = value.trim();
      return normalizedValue.startsWith('http://') || normalizedValue.startsWith('https://') || normalizedValue.startsWith('data:') || normalizedValue.startsWith('blob:');
    },
    isFileValue(value) {
      return typeof File !== 'undefined' && value instanceof File;
    },
    // ── S1-P1 Snippet validation helpers ──
    isSnippedColorValid(value) {
      if (value === null || value === undefined || value === '') {
        return true; // empty = clear/default (allowed)
      }
      return /^#[0-9A-Fa-f]{6}$/.test(String(value).trim());
    },
    isSnippedOffsetValid(value) {
      if (value === null || value === undefined || value === '') {
        return true; // empty = default position (allowed)
      }
      return Number.isInteger(Number(value));
    },
    hexColorRule(value) {
      return this.isSnippedColorValid(value) || this.$t('_HexColorFormat');
    },
    integerRule(value) {
      return this.isSnippedOffsetValid(value) || this.$t('_IntegerOnly');
    },
    // ต่างจาก isSnippedOffsetValid: ในโหมด custom ค่าว่าง = invalid (ไม่มี default ให้ fallback ฝั่ง admin)
    isSnippedPanelHeightValid(mode, value) {
      if (mode !== 'custom') {
        return true;
      }
      if (value === null || value === undefined || value === '') {
        return false;
      }
      const n = Number(value);
      return Number.isInteger(n) && n >= SNIPPED_PANEL_HEIGHT_MIN && n <= SNIPPED_PANEL_HEIGHT_MAX;
    },
    panelHeightRule(value) {
      return this.isSnippedPanelHeightValid(this.ConfigData.SnippedPanelHeightMode, value) || this.$t('_PanelHeightRange', { min: SNIPPED_PANEL_HEIGHT_MIN, max: SNIPPED_PANEL_HEIGHT_MAX });
    },
    swatchColor(value) {
      return this.isSnippedColorValid(value) && value ? value : 'transparent';
    },
    async inputSnippedLauncherIcon(evt) {
      let file = evt.target.files;
      if (file.length > 0) {
        let data = file[0];
        const flagUpload = await this.CheckSizeIMG(data, 2);
        if (flagUpload) {
          this.ConfigData.IsImgSnippedLauncherIcon = true;
          this.onFileChange(file, 'SnippedLauncherIcon');
        }
      }
    },
    selectSnippedLauncherIcon(icon) {
      this.ConfigData.SnippedLauncherIcon = icon;
      this.ConfigData.IsImgSnippedLauncherIcon = false;
      if (this._snippedLauncherIconBlobPreviewUrl) {
        URL.revokeObjectURL(this._snippedLauncherIconBlobPreviewUrl);
        this._snippedLauncherIconBlobPreviewUrl = null;
      }
      this.images.SnippedLauncherIcon = null;
    },
    applyAllThemeDefaults() {
      this.ConfigData.ChatbotName = THEME_DEFAULTS.chatbotName;
      this.ConfigData.ChatbotIcon = THEME_DEFAULTS.chatbotIcon;
      this.ConfigData.FontColorTitle = THEME_DEFAULTS.fontColorTitle;
      this.ConfigData.chatColorTheme = THEME_DEFAULTS.chatColorTheme;
      this.ConfigData.NavbarBtnColorTheme = THEME_DEFAULTS.navbarBtnColorTheme;
      this.ConfigData.NavbarTxtColorTheme = THEME_DEFAULTS.navbarTxtColorTheme;
      this.ConfigData.FullstreamNavbarBtnColorTheme = THEME_DEFAULTS.fullstreamNavbarBtnColorTheme;
      this.ConfigData.FullstreamNavbarTxtColorTheme = THEME_DEFAULTS.fullstreamNavbarTxtColorTheme;
      this.ConfigData.FullstreamNavbarIconColorTheme = THEME_DEFAULTS.fullstreamNavbarIconColorTheme;
      this.ConfigData.FullstreamChatColorTheme = THEME_DEFAULTS.fullstreamChatColorTheme;
      this.ConfigData.snippedColorThemeChat = THEME_DEFAULTS.snippedColorThemeChat;
      this.ConfigData.SnippedIcon = THEME_DEFAULTS.snippedIcon;
      this.ConfigData.SnippedIconColor = THEME_DEFAULTS.snippedIconColor;
      this.ConfigData.SnippedHeaderColorTheme = THEME_DEFAULTS.snippedHeaderColorTheme;
      this.ConfigData.SnippedFontColorTheme = THEME_DEFAULTS.snippedFontColorTheme;
      this.ConfigData.ChatPanelHeaderColorTheme = THEME_DEFAULTS.chatPanelHeaderColorTheme;
      this.ConfigData.ChatPanelFontColorTheme = THEME_DEFAULTS.chatPanelFontColorTheme;
      // ── S1-P1: reset 20 new snippet fields to defaults (mirror data() init) ──
      // ① Launcher
      this.ConfigData.SnippedLauncherShape = 'circle';
      this.ConfigData.SnippedLauncherVariant = 'default';
      this.ConfigData.SnippedLauncherText = '';
      this.ConfigData.SnippedLauncherTextColor = '#FFFFFF';
      this.ConfigData.SnippedLauncherBgColor = '';
      this.ConfigData.SnippedLauncherIcon = '';
      this.ConfigData.IsImgSnippedLauncherIcon = false;
      this.ConfigData.SnippedLauncherPosition = 'bottom-right';
      this.ConfigData.SnippedLauncherOffsetX = null;
      this.ConfigData.SnippedLauncherOffsetY = null;
      // ② Teaser
      this.ConfigData.SnippedTeaserEnabled = false;
      this.ConfigData.SnippedTeaserBgColor = '';
      this.ConfigData.SnippedTeaserTextColor = '';
      // ③ Panel
      this.ConfigData.SnippedHeaderSubtitle = '';
      this.ConfigData.SnippedDisclaimerText = '';
      this.ConfigData.SnippedPanelBorderColor = '';
      this.ConfigData.SnippedInputPlaceholder = '';
      this.ConfigData.SnippedTypingText = '';
      // ④ Toggles
      this.ConfigData.SnippedShowBotName = false;
      this.ConfigData.SnippedShowModelTopicBar = true;
      // ⑤ S1-P2 Panel height
      this.ConfigData.SnippedPanelHeightMode = 'default';
      this.ConfigData.SnippedPanelHeight = null;
      this.images.SnippedLauncherIcon = null;
      this.ConfigData.isChatbotIconEnabled = true;
      this.ConfigData.isImgIconChat = false;
      this.images.SnippedIcon = null;
      this.fullstreamPreview = { ...FULLSTREAM_PREVIEW_DEFAULTS };
      this.colorPickerKey++;
    },
    applyConfigThemeData(data) {
      if (!data) {
        return;
      }

      this.ConfigData.ChatbotName = data.nameChat || THEME_DEFAULTS.chatbotName;
      const hasConfiguredChatbotIcon = data.iconChat != null && data.iconChat !== '';
      this.ConfigData.isChatbotIconEnabled = data.isImgIconChat || hasConfiguredChatbotIcon;
      const configuredChatbotIcon = hasConfiguredChatbotIcon ? data.iconChat : null;
      this.ConfigData.ChatbotIcon = data.isImgIconChat ? '' : configuredChatbotIcon;
      this.ConfigData.FontColorTitle = data.fontColorTitle ? `#${data.fontColorTitle}` : THEME_DEFAULTS.fontColorTitle;
      this.ConfigData.chatColorTheme = data.colorThemeChat ? `#${data.colorThemeChat}` : THEME_DEFAULTS.chatColorTheme;
      this.ConfigData.NavbarBtnColorTheme = data.navbarButton ? `#${data.navbarButton}` : THEME_DEFAULTS.navbarBtnColorTheme;
      this.ConfigData.NavbarTxtColorTheme = data.navbarColorText ? `#${data.navbarColorText}` : THEME_DEFAULTS.navbarTxtColorTheme;
      this.ConfigData.snippedColorThemeChat = data.snippedColorThemeChat ? `#${data.snippedColorThemeChat}` : THEME_DEFAULTS.snippedColorThemeChat;
      this.ConfigData.SnippedIcon = data.snippedIcon ?? null;
      this.ConfigData.SnippedIconColor = this.formatThemeColor(data.snippedIconColor, THEME_DEFAULTS.snippedIconColor);
      this.ConfigData.SnippedHeaderColorTheme = this.formatThemeColor(data.snippedHeaderColorTheme, THEME_DEFAULTS.snippedHeaderColorTheme);
      this.ConfigData.SnippedFontColorTheme = this.formatThemeColor(data.snippedFontColorTheme, THEME_DEFAULTS.snippedFontColorTheme);
      this.ConfigData.ChatPanelHeaderColorTheme = this.formatThemeColor(data.chatPanelHeaderColorTheme, THEME_DEFAULTS.chatPanelHeaderColorTheme);
      this.ConfigData.ChatPanelFontColorTheme = this.formatThemeColor(data.chatPanelFontColorTheme, THEME_DEFAULTS.chatPanelFontColorTheme);
      this.ConfigData.isImgIconChat = this.ConfigData.isChatbotIconEnabled && Boolean(data.isImgIconChat);
      this.images.SnippedIcon = this.isUrlLikeIcon(data.snippedIcon) ? data.snippedIcon : null;

      this.applySnippetThemeFields(data);
    },
    applySnippetThemeFields(data) {
      // ── S1-P1: 20 Snippet widget fields (camelCase from API; empty/null = default/clear) ──
      // ① Launcher
      this.ConfigData.SnippedLauncherShape = data.snippedLauncherShape ?? 'circle';
      this.ConfigData.SnippedLauncherVariant = data.snippedLauncherVariant || 'default';
      this.ConfigData.SnippedLauncherText = data.snippedLauncherText ?? '';
      this.ConfigData.SnippedLauncherTextColor = this.formatThemeColor(data.snippedLauncherTextColor, '#FFFFFF');
      this.ConfigData.SnippedLauncherBgColor = data.snippedLauncherBgColor ? `#${data.snippedLauncherBgColor}` : '';
      const launcherIconIsUrl = this.isUrlLikeIcon(data.snippedLauncherIcon);
      this.ConfigData.IsImgSnippedLauncherIcon = data.isImgSnippedLauncherIcon === true || launcherIconIsUrl;
      this.images.SnippedLauncherIcon = launcherIconIsUrl ? data.snippedLauncherIcon : null;
      this.ConfigData.SnippedLauncherIcon = launcherIconIsUrl ? '' : (data.snippedLauncherIcon ?? '');
      this.ConfigData.SnippedLauncherPosition = data.snippedLauncherPosition ?? 'bottom-right';
      this.ConfigData.SnippedLauncherOffsetX = data.snippedLauncherOffsetX ?? null;
      this.ConfigData.SnippedLauncherOffsetY = data.snippedLauncherOffsetY ?? null;
      // ② Teaser
      this.ConfigData.SnippedTeaserEnabled = data.snippedTeaserEnabled === true;
      this.ConfigData.SnippedTeaserBgColor = data.snippedTeaserBgColor ? `#${data.snippedTeaserBgColor}` : '';
      this.ConfigData.SnippedTeaserTextColor = data.snippedTeaserTextColor ? `#${data.snippedTeaserTextColor}` : '';
      // ③ Panel
      this.ConfigData.SnippedHeaderSubtitle = data.snippedHeaderSubtitle ?? '';
      this.ConfigData.SnippedDisclaimerText = data.snippedDisclaimerText ?? '';
      this.ConfigData.SnippedPanelBorderColor = data.snippedPanelBorderColor ? `#${data.snippedPanelBorderColor}` : '';
      this.ConfigData.SnippedInputPlaceholder = data.snippedInputPlaceholder ?? '';
      this.ConfigData.SnippedTypingText = data.snippedTypingText ?? '';
      // ④ Toggles (null-preserving: default-off for botname, default-on for model/topic bar)
      this.ConfigData.SnippedShowBotName = data.snippedShowBotName === true;
      this.ConfigData.SnippedShowModelTopicBar = data.snippedShowModelTopicBar ?? true;
      // ── R2: 9 display settings (null = never set → default-on for every toggle) ──
      this.ConfigData.SnippedBotBubbleColor = this.formatThemeColor(data.snippedBotBubbleColor, THEME_DEFAULTS.snippedBotBubbleColor);
      this.ConfigData.SnippedBotFontColor = this.formatThemeColor(data.snippedBotFontColor, THEME_DEFAULTS.snippedBotFontColor);
      this.ConfigData.SnippedSendButtonColor = data.snippedSendButtonColor ? `#${data.snippedSendButtonColor}` : '';
      this.ConfigData.SnippedSendButtonVariant = data.snippedSendButtonVariant || 'default';
      this.ConfigData.SnippedShowHeaderSubtitle = data.snippedShowHeaderSubtitle ?? true;
      this.ConfigData.SnippedShowVersion = data.snippedShowVersion ?? true;
      this.ConfigData.SnippedShowCharCounter = data.snippedShowCharCounter ?? true;
      this.ConfigData.SnippedShowSnippedIcon = data.snippedShowSnippedIcon ?? true;
      this.ConfigData.SnippedShowLauncherIcon = data.snippedShowLauncherIcon ?? true;
      this.ConfigData.SnippedPanelHeightMode = SNIPPED_PANEL_HEIGHT_MODES.includes(data.snippedPanelHeightMode) ? data.snippedPanelHeightMode : 'default';
      this.ConfigData.SnippedPanelHeight = data.snippedPanelHeight ?? null;
    },
    applyFullstreamThemeData(data) {
      if (!data) {
        return;
      }

      this.ConfigData.FullstreamNavbarBtnColorTheme = this.formatThemeColor(data.fullstreamNavbarBtnColorTheme, THEME_DEFAULTS.fullstreamNavbarBtnColorTheme);
      this.ConfigData.FullstreamNavbarTxtColorTheme = this.formatThemeColor(data.fullstreamNavbarTxtColorTheme, THEME_DEFAULTS.fullstreamNavbarTxtColorTheme);
      this.ConfigData.FullstreamNavbarIconColorTheme = this.formatThemeColor(data.fullstreamNavbarIconColorTheme, THEME_DEFAULTS.fullstreamNavbarIconColorTheme);
      this.ConfigData.FullstreamChatColorTheme = this.formatThemeColor(data.fullstreamChatColorTheme, THEME_DEFAULTS.fullstreamChatColorTheme);
      this.fullstreamPreview = {
        welcomeTitle: data.fullstreamWelcomeTitle ?? FULLSTREAM_PREVIEW_DEFAULTS.welcomeTitle,
        welcomeSubtitle: data.fullstreamWelcomeSubtitle ?? FULLSTREAM_PREVIEW_DEFAULTS.welcomeSubtitle,
        disclaimerText: data.fullstreamDisclaimerText ?? FULLSTREAM_PREVIEW_DEFAULTS.disclaimerText,
      };
    },
    applyConfigThemeImages(loginLogoC, chatIcon, navLogo, navBG, subBG, snippedLogo) {
      this.images.ChatbotIcon = this.ConfigData.isChatbotIconEnabled ? chatIcon || this.images.ChatbotIcon : null;
      this.images.Loginlogo = loginLogoC || this.images.Loginlogo;
      this.images.navlogo = navLogo || this.images.navlogo;
      this.images.navBG = navBG || this.images.navBG;
      this.images.subNavBG = subBG || subNavBGImg;
      this.images.snippedlogo = snippedLogo || DEFAULT_SNIPPED_LOGO_URL;
    },
    async Get() {
      try {
        const [data, loginLogoC, chatIcon, navLogo, navBG, subBG, snippedLogo] = await Promise.all([
          new Promise((resolve) => {
            this.$call.GetConfigThem((response) => {
              resolve(response.data);
            });
          }),
          this.getIMG('LoginLogo.png'),
          this.getIMG('ChatIcon.png'),
          this.getIMG('NavLogo.png'),
          this.getIMG('NavBG.png'),
          this.getIMG('SubBG.png'),
          this.getIMG('SnippedLogo.png'),
        ]);
        this.applyConfigThemeData(data);
        this.applyFullstreamThemeData(data);
        this.applyConfigThemeImages(loginLogoC, chatIcon, navLogo, navBG, subBG, snippedLogo);
        this.dialog = false;
      } catch (error) {
        console.error('An error occurred while loading config:', error);
      }
    },
    convertUTCDateToLocalDate(date) {
      date = new Date(date);

      let timezone = date.getTimezoneOffset() * 60000;
      let newDate = new Date(date.getTime() - timezone);
      let output = newDate.getDate() + '/' + newDate.getMonth() + '/' + newDate.getFullYear() + '   ' + newDate.getHours() + ':' + newDate.getMinutes();

      return output;
    },
    createImage(file, name) {
      const reader = new FileReader();
      reader.onload = (e) => {
        // Convert to base64
        if (name == 'Loginlogo') {
          this.images.Loginlogo = e.target.result;
        } else if (name == 'ChatbotIcon') {
          this.images.ChatbotIcon = e.target.result;
        } else if (name == 'SnippedIcon') {
          this.images.SnippedIcon = e.target.result;
        } else if (name == 'NavLogo') {
          this.images.navlogo = e.target.result;
        } else if (name == 'NavBG') {
          this.images.navBG = e.target.result;
        } else if (name == 'SubBG') {
          this.images.subNavBG = e.target.result;
        } else if (name == 'Snippedlogo') {
          this.images.snippedlogo = e.target.result;
        }
      };
      reader.readAsDataURL(file);
    },
    async inputChatIcon(evt) {
      let file = evt.target.files; //[0]
      if (file.length > 0) {
        let data = file[0];
        const flagUpload = await this.CheckSizeIMG(data, 1024, 1024, 2);
        if (flagUpload) {
          this.ConfigData.isChatbotIconEnabled = true;
          this.ConfigData.isImgIconChat = true;
          this.onFileChange(file, 'ChatbotIcon');
        }
      } else {
        return;
      }
    },
    async inputSnippedIcon(evt) {
      let file = evt.target.files;
      if (file.length > 0) {
        let data = file[0];
        const flagUpload = await this.CheckSizeIMG(data, 2);
        if (flagUpload) {
          this.onFileChange(file, 'SnippedIcon');
        }
      }
    },
    selectChatbotIcon(icon) {
      this.ConfigData.isChatbotIconEnabled = true;
      this.ConfigData.ChatbotIcon = icon;
      this.ConfigData.isImgIconChat = false;
    },
    selectSnippedIcon(icon) {
      this.ConfigData.SnippedIcon = icon;
      if (this._snippedIconBlobPreviewUrl) {
        URL.revokeObjectURL(this._snippedIconBlobPreviewUrl);
        this._snippedIconBlobPreviewUrl = null;
      }
      this.images.SnippedIcon = null;
    },
    toggleChatbotIcon(enabled) {
      if (enabled) {
        this.ConfigData.ChatbotIcon = this.ConfigData.ChatbotIcon || THEME_DEFAULTS.chatbotIcon;
        this.ConfigData.isImgIconChat = false;
        return;
      }

      this.ConfigData.ChatbotIcon = null;
      this.ConfigData.ChatIcon = null;
      this.ConfigData.isImgIconChat = false;
      this.images.ChatbotIcon = null;
      const fileInput = document.getElementById('img-upload');
      if (fileInput) {
        fileInput.value = '';
      }
    },
    async CheckSizeIMG(file, limitFile) {
      const maxFileSize = limitFile * 1024 * 1024;
      // ตรวจสอบขนาดของไฟล์

      return new Promise((resolve) => {
        if (file.size > maxFileSize) {
          this.openWarningDialog(this.$t('warning'), this.$t('_FileSizeExceedMB', { size: limitFile }), false, 3000);
          resolve(false);
        } else {
          resolve(true);
        }
      });
    },
    async onFileChange(file, name) {
      let data = file[0];

      // Validate file format (only jpg and png)
      const fileExtension = data.name.split('.').pop().toLowerCase();
      const allowedFormats = ['jpg', 'jpeg', 'png'];

      if (!allowedFormats.includes(fileExtension)) {
        this.openWarningDialog(this.$t('_UnsupportedFileFormat'), this.$t('_UploadPngJpegMax10MB'), true);
        return;
      }

      // Validate file size (max 10MB)
      const maxFileSize = 10 * 1024 * 1024; // 10MB in bytes
      if (data.size > maxFileSize) {
        this.openWarningDialog(this.$t('_UnsupportedFileFormat'), this.$t('_UploadPngJpegMax10MB'), true);
        return;
      }

      let maximunWidth = 0;
      let maximunHeight = 0;
      const img = new Image();
      const objectURL = URL.createObjectURL(data);
      img.src = objectURL;

      if (!file) {
        return;
      }

      if (name == 'Loginlogo') {
        maximunWidth = 1024;
        maximunHeight = 1024;
        img.onload = () => {
          if (img.width > maximunWidth || img.height > maximunHeight) {
            this.openWarningDialog(this.$t('warning'), this.$t('_ImageSizeExceed', { width: maximunWidth, height: maximunHeight }), false, 3000);
            return;
          } else {
            this.ConfigData.LoginLogo = data;
            this.createImage(data, name);
          }
          URL.revokeObjectURL(objectURL);
        };
      } else if (name == 'ChatbotIcon') {
        maximunWidth = 800;
        maximunHeight = 800;
        img.onload = () => {
          if (img.width > maximunWidth || img.height > maximunHeight) {
            this.openWarningDialog(this.$t('warning'), this.$t('_ImageSizeExceed', { width: maximunWidth, height: maximunHeight }), false, 3000);
            URL.revokeObjectURL(objectURL);
          } else {
            this.ConfigData.isChatbotIconEnabled = true;
            this.ConfigData.ChatbotIcon = data;
            // Revoke previous blob preview URL before replacing
            if (this._chatIconBlobPreviewUrl) {
              URL.revokeObjectURL(this._chatIconBlobPreviewUrl);
            }
            this._chatIconBlobPreviewUrl = objectURL;
            this.images.ChatbotIcon = objectURL;
          }
        };
      } else if (name == 'NavLogo') {
        maximunWidth = 2560;
        maximunHeight = 1440;
        img.onload = () => {
          if (img.width > maximunWidth || img.height > maximunHeight) {
            this.openWarningDialog(this.$t('warning'), this.$t('_ImageSizeExceed', { width: maximunWidth, height: maximunHeight }), false, 3000);
            return;
          } else {
            this.ConfigData.navlogo = data;
            this.createImage(data, name);
          }
          URL.revokeObjectURL(objectURL);
        };
      } else if (name == 'NavBG') {
        maximunWidth = 2560;
        maximunHeight = 1440;
        img.onload = () => {
          if (img.width > maximunWidth || img.height > maximunHeight) {
            this.openWarningDialog(this.$t('warning'), this.$t('_ImageSizeExceed', { width: maximunWidth, height: maximunHeight }), false, 3000);
            return;
          } else {
            this.ConfigData.navBG = data;
            this.createImage(data, name);
          }
          URL.revokeObjectURL(objectURL);
        };
      } else if (name == 'SubBG') {
        maximunWidth = 2560;
        maximunHeight = 1440;
        img.onload = () => {
          if (img.width > maximunWidth || img.height > maximunHeight) {
            this.openWarningDialog(this.$t('warning'), this.$t('_ImageSizeExceed', { width: maximunWidth, height: maximunHeight }), false, 3000);
            return;
          } else {
            this.ConfigData.subNavBG = data;
            this.createImage(data, name);
          }
          URL.revokeObjectURL(objectURL);
        };
      } else if (name == 'Snippedlogo') {
        maximunWidth = 2560;
        maximunHeight = 1440;
        img.onload = () => {
          if (img.width > maximunWidth || img.height > maximunHeight) {
            this.openWarningDialog(this.$t('warning'), this.$t('_ImageSizeExceed', { width: maximunWidth, height: maximunHeight }), false, 3000);
            return;
          } else {
            this.ConfigData.snippedlogo = data;
            this.createImage(data, name);
          }
          URL.revokeObjectURL(objectURL);
        };
      } else if (name == 'SnippedIcon') {
        maximunWidth = 800;
        maximunHeight = 800;
        img.onload = () => {
          if (img.width > maximunWidth || img.height > maximunHeight) {
            this.openWarningDialog(this.$t('warning'), this.$t('_ImageSizeExceed', { width: maximunWidth, height: maximunHeight }), false, 3000);
            URL.revokeObjectURL(objectURL);
            return;
          }

          this.ConfigData.SnippedIcon = data;
          if (this._snippedIconBlobPreviewUrl) {
            URL.revokeObjectURL(this._snippedIconBlobPreviewUrl);
          }
          this._snippedIconBlobPreviewUrl = objectURL;
          this.images.SnippedIcon = objectURL;
        };
      } else if (name == 'SnippedLauncherIcon') {
        maximunWidth = 800;
        maximunHeight = 800;
        img.onload = () => {
          if (img.width > maximunWidth || img.height > maximunHeight) {
            this.openWarningDialog(this.$t('warning'), this.$t('_ImageSizeExceed', { width: maximunWidth, height: maximunHeight }), false, 3000);
            URL.revokeObjectURL(objectURL);
            return;
          }

          this.ConfigData.SnippedLauncherIcon = data;
          this.ConfigData.IsImgSnippedLauncherIcon = true;
          if (this._snippedLauncherIconBlobPreviewUrl) {
            URL.revokeObjectURL(this._snippedLauncherIconBlobPreviewUrl);
          }
          this._snippedLauncherIconBlobPreviewUrl = objectURL;
          this.images.SnippedLauncherIcon = objectURL;
        };
      }
    },
    setAsDefault(txt) {
      switch (txt) {
        case 'Loginlogo': {
          this.images.Loginlogo = LoginlogoImg;
          this.ConfigData.LoginLogo = false;
          this.resetLogo = true;
          break;
        }
        case 'ChatbotIcon': {
          this.ConfigData.isChatbotIconEnabled = true;
          this.ConfigData.isImgIconChat = false;
          this.ConfigData.ChatbotIcon = THEME_DEFAULTS.chatbotIcon;
          this.ConfigData.chatColorTheme = THEME_DEFAULTS.chatColorTheme;
          this.ConfigData.ChatbotName = THEME_DEFAULTS.chatbotName;
          break;
        }
        case 'FullstreamChatbotIcon': {
          this.ConfigData.isChatbotIconEnabled = true;
          this.ConfigData.isImgIconChat = false;
          this.ConfigData.ChatbotIcon = THEME_DEFAULTS.chatbotIcon;
          this.ConfigData.ChatbotName = THEME_DEFAULTS.chatbotName;
          break;
        }
        case 'NavLogo': {
          this.images.navlogo = navlogoImg;
          this.ConfigData.navlogo = false;
          this.resetHeaderLogo = true;
          break;
        }
        case 'NavBG': {
          this.images.navBG = navBGImg;
          this.ConfigData.navBG = false;
          this.resetNavBg = true;
          break;
        }
        case 'SubBG': {
          this.images.subNavBG = subNavBGImg;
          this.ConfigData.subNavBG = false;
          this.resetTitleBg = true;
          break;
        }
        case 'Snippedlogo': {
          this.images.snippedlogo = DEFAULT_SNIPPED_LOGO_URL;
          this.ConfigData.snippedlogo = false;
          this.resetSnippedLogo = true;
          break;
        }
        case 'ButtonColor': {
          this.ConfigData.NavbarBtnColorTheme = THEME_DEFAULTS.navbarBtnColorTheme;
          break;
        }
        case 'TextColor': {
          this.ConfigData.NavbarTxtColorTheme = THEME_DEFAULTS.navbarTxtColorTheme;
          break;
        }
        case 'ChatColor': {
          this.ConfigData.chatColorTheme = THEME_DEFAULTS.chatColorTheme;
          break;
        }
        case 'FullstreamButtonColor': {
          this.ConfigData.FullstreamNavbarBtnColorTheme = THEME_DEFAULTS.fullstreamNavbarBtnColorTheme;
          break;
        }
        case 'FullstreamTextColor': {
          this.ConfigData.FullstreamNavbarTxtColorTheme = THEME_DEFAULTS.fullstreamNavbarTxtColorTheme;
          break;
        }
        case 'FullstreamNavbarIconColor': {
          this.ConfigData.FullstreamNavbarIconColorTheme = THEME_DEFAULTS.fullstreamNavbarIconColorTheme;
          break;
        }
        case 'FullstreamChatColor': {
          this.ConfigData.FullstreamChatColorTheme = THEME_DEFAULTS.fullstreamChatColorTheme;
          break;
        }
        case 'FontColor': {
          this.ConfigData.FontColorTitle = THEME_DEFAULTS.fontColorTitle;
          break;
        }
        case 'SnippedColor': {
          this.ConfigData.snippedColorThemeChat = THEME_DEFAULTS.snippedColorThemeChat;
          break;
        }
        case 'SnippedIcon': {
          this.ConfigData.SnippedIcon = THEME_DEFAULTS.snippedIcon;
          if (this._snippedIconBlobPreviewUrl) {
            URL.revokeObjectURL(this._snippedIconBlobPreviewUrl);
            this._snippedIconBlobPreviewUrl = null;
          }
          this.images.SnippedIcon = null;
          break;
        }
        case 'SnippedLauncherIcon': {
          this.ConfigData.SnippedLauncherIcon = THEME_DEFAULTS.snippedIcon;
          this.ConfigData.IsImgSnippedLauncherIcon = false;
          if (this._snippedLauncherIconBlobPreviewUrl) {
            URL.revokeObjectURL(this._snippedLauncherIconBlobPreviewUrl);
            this._snippedLauncherIconBlobPreviewUrl = null;
          }
          this.images.SnippedLauncherIcon = null;
          break;
        }
        case 'SnippedLauncherTextColor': {
          this.ConfigData.SnippedLauncherTextColor = '#FFFFFF';
          break;
        }
        case 'SnippedLauncherBgColor': {
          this.ConfigData.SnippedLauncherBgColor = '';
          break;
        }
        case 'SnippedTeaserBgColor': {
          this.ConfigData.SnippedTeaserBgColor = '';
          break;
        }
        case 'SnippedTeaserTextColor': {
          this.ConfigData.SnippedTeaserTextColor = '';
          break;
        }
        case 'SnippedPanelBorderColor': {
          this.ConfigData.SnippedPanelBorderColor = '';
          break;
        }
        case 'SnippedIconColor': {
          this.ConfigData.SnippedIconColor = THEME_DEFAULTS.snippedIconColor;
          break;
        }
        case 'SnippedHeaderColor': {
          this.ConfigData.SnippedHeaderColorTheme = THEME_DEFAULTS.snippedHeaderColorTheme;
          break;
        }
        case 'SnippedFontColor': {
          this.ConfigData.SnippedFontColorTheme = THEME_DEFAULTS.snippedFontColorTheme;
          break;
        }
        case 'SnippedBotBubbleColor': {
          this.ConfigData.SnippedBotBubbleColor = THEME_DEFAULTS.snippedBotBubbleColor;
          break;
        }
        case 'SnippedBotFontColor': {
          this.ConfigData.SnippedBotFontColor = THEME_DEFAULTS.snippedBotFontColor;
          break;
        }
        case 'SnippedSendButtonColor': {
          this.ConfigData.SnippedSendButtonColor = THEME_DEFAULTS.snippedSendButtonColor;
          break;
        }
        case 'ChatPanelHeaderColor': {
          this.ConfigData.ChatPanelHeaderColorTheme = THEME_DEFAULTS.chatPanelHeaderColorTheme;
          break;
        }
        case 'ChatPanelFontColor': {
          this.ConfigData.ChatPanelFontColorTheme = THEME_DEFAULTS.chatPanelFontColorTheme;
          break;
        }
        default:
          break;
      }
      this.colorPickerKey++;
    },
    resetFullstreamPreview() {
      this.fullstreamPreview = { ...FULLSTREAM_PREVIEW_DEFAULTS };
      this.setAsDefault('FullstreamButtonColor');
      this.setAsDefault('FullstreamTextColor');
      this.setAsDefault('FullstreamNavbarIconColor');
      this.setAsDefault('FullstreamChatColor');
    },
    setDefault() {
      this.closeDefaultDialog();
      this.dialog = true;
      this.$call.SetDefault(
        (dataResponse) => {
          this.dialog = false;
          if (dataResponse.status == 0) {
            this.applyAllThemeDefaults();
            this.SuccessMessage = this.$t('_ChangedDefaultStyle');
            this.showSuccess = true;
            clearTimeout(this._addToastTimer);
            this._addToastTimer = setTimeout(() => {
              this.showSuccess = false;
            }, 1500);
            this.resetLogo = true;
            this.resetHeaderLogo = true;
            this.resetNavBg = true;
            this.resetTitleBg = true;
            this.resetSnippedLogo = true;
          }
          globalThis.location.reload();
        },
        (errorResource) => {
          this.dialog = false;
          console.error(errorResource);
        }
      );
    },
    buildResetDefaults(isChatbotIconEnabled) {
      // Collect the "reset to default" image ids (matches controller DefaultIMG). Extracted from save()
      // to keep save() under SonarQube's cognitive-complexity threshold; behavior is unchanged.
      // NOTE: image flags are tri-state — object/url = has image · null = untouched · false = user reset.
      // Match "exactly false" (Object.is) so an untouched null does NOT get reset. `!x` would wrongly reset null.
      const setDefault = [];
      if (Object.is(this.ConfigData.LoginLogo, false)) {
        setDefault.push(1);
      }
      if (Object.is(this.ConfigData.navlogo, false)) {
        setDefault.push(2);
      }
      if (Object.is(this.ConfigData.navBG, false)) {
        setDefault.push(3);
      }
      if (Object.is(this.ConfigData.subNavBG, false)) {
        setDefault.push(4);
      }
      if (!isChatbotIconEnabled) {
        setDefault.push(5);
      }
      if (Object.is(this.ConfigData.snippedlogo, false)) {
        setDefault.push(6);
      }
      return setDefault;
    },
    save() {
      // Guard with the same predicate as the Save button's :disabled (loading or validation error).
      if (this.dialog || this.hasSnippedValidationError) {
        return;
      }
      this.dialog = true;
      const isChatbotIconEnabled = this.ConfigData.isChatbotIconEnabled !== false;
      let isImgChat = isChatbotIconEnabled ? (this.ConfigData.isImgIconChat ?? false) : false;
      const setDefaultJson = JSON.stringify(this.buildResetDefaults(isChatbotIconEnabled));
      const formData = new FormData();
      formData.append('LoginLogo', this.ConfigData.LoginLogo);
      formData.append('NavLogo', this.ConfigData.navlogo);
      formData.append('NavBG', this.ConfigData.navBG);
      formData.append('SubBG', this.ConfigData.subNavBG);
      formData.append('SnippedLogo', this.ConfigData.snippedlogo);
      formData.append('ChatbotName', this.ConfigData.ChatbotName);
      formData.append('ChatbotIcon', isChatbotIconEnabled && !isImgChat ? (this.ConfigData.ChatbotIcon ?? '') : '');
      formData.append('FontColorTitle', this.ConfigData.FontColorTitle.replace('#', ''));
      formData.append('chatColorTheme', this.ConfigData.chatColorTheme.replace('#', ''));
      formData.append('NavbarBtnColorTheme', this.ConfigData.NavbarBtnColorTheme.replace('#', ''));
      formData.append('NavbarTxtColorTheme', this.ConfigData.NavbarTxtColorTheme.replace('#', ''));
      formData.append('snippedchatColorTheme', this.ConfigData.snippedColorThemeChat.replace('#', ''));
      formData.append('SnippedIcon', this.isFileValue(this.ConfigData.SnippedIcon) ? '' : (this.ConfigData.SnippedIcon ?? ''));
      formData.append('SnippedIconColor', this.ConfigData.SnippedIconColor.replace('#', ''));
      formData.append('SnippedHeaderColorTheme', this.ConfigData.SnippedHeaderColorTheme.replace('#', ''));
      formData.append('SnippedFontColorTheme', this.ConfigData.SnippedFontColorTheme.replace('#', ''));
      formData.append('ChatPanelHeaderColorTheme', this.ConfigData.ChatPanelHeaderColorTheme.replace('#', ''));
      formData.append('ChatPanelFontColorTheme', this.ConfigData.ChatPanelFontColorTheme.replace('#', ''));
      formData.append('FullstreamWelcomeTitle', this.fullstreamPreview.welcomeTitle);
      formData.append('FullstreamWelcomeSubtitle', this.fullstreamPreview.welcomeSubtitle);
      formData.append('FullstreamDisclaimerText', this.fullstreamPreview.disclaimerText);
      formData.append('FullstreamNavbarBtnColorTheme', this.ConfigData.FullstreamNavbarBtnColorTheme.replace('#', ''));
      formData.append('FullstreamNavbarTxtColorTheme', this.ConfigData.FullstreamNavbarTxtColorTheme.replace('#', ''));
      formData.append('FullstreamNavbarIconColorTheme', this.ConfigData.FullstreamNavbarIconColorTheme.replace('#', ''));
      formData.append('FullstreamChatColorTheme', this.ConfigData.FullstreamChatColorTheme.replace('#', ''));
      // ── S1-P1: 20 Snippet widget fields (exact controller form names). Colors strip '#'; int/bool as string. ──
      const isImgLauncherIcon = this.ConfigData.IsImgSnippedLauncherIcon === true || this.isFileValue(this.ConfigData.SnippedLauncherIcon);
      // ① Launcher
      formData.append('SnippedLauncherShape', this.ConfigData.SnippedLauncherShape ?? '');
      formData.append('SnippedLauncherVariant', this.ConfigData.SnippedLauncherVariant ?? '');
      formData.append('SnippedLauncherText', this.ConfigData.SnippedLauncherText ?? '');
      formData.append('SnippedLauncherTextColor', (this.ConfigData.SnippedLauncherTextColor ?? '').replace('#', ''));
      formData.append('SnippedLauncherBgColor', (this.ConfigData.SnippedLauncherBgColor ?? '').replace('#', ''));
      formData.append('SnippedLauncherIcon', isImgLauncherIcon ? '' : (this.ConfigData.SnippedLauncherIcon ?? ''));
      formData.append('SnippedLauncherPosition', this.ConfigData.SnippedLauncherPosition ?? '');
      formData.append('SnippedLauncherOffsetX', String(this.ConfigData.SnippedLauncherOffsetX ?? ''));
      formData.append('SnippedLauncherOffsetY', String(this.ConfigData.SnippedLauncherOffsetY ?? ''));
      // ② Teaser
      formData.append('SnippedTeaserEnabled', String(this.ConfigData.SnippedTeaserEnabled === true));
      formData.append('SnippedTeaserBgColor', (this.ConfigData.SnippedTeaserBgColor ?? '').replace('#', ''));
      formData.append('SnippedTeaserTextColor', (this.ConfigData.SnippedTeaserTextColor ?? '').replace('#', ''));
      // ③ Panel
      formData.append('SnippedHeaderSubtitle', this.ConfigData.SnippedHeaderSubtitle ?? '');
      formData.append('SnippedDisclaimerText', this.ConfigData.SnippedDisclaimerText ?? '');
      formData.append('SnippedPanelBorderColor', (this.ConfigData.SnippedPanelBorderColor ?? '').replace('#', ''));
      formData.append('SnippedInputPlaceholder', this.ConfigData.SnippedInputPlaceholder ?? '');
      formData.append('SnippedTypingText', this.ConfigData.SnippedTypingText ?? '');
      // ④ Toggles
      formData.append('SnippedShowBotName', String(this.ConfigData.SnippedShowBotName === true));
      formData.append('SnippedShowModelTopicBar', String(this.ConfigData.SnippedShowModelTopicBar !== false));
      // ── R2: 9 snippet display settings ──
      formData.append('SnippedBotBubbleColor', (this.ConfigData.SnippedBotBubbleColor ?? '').replace('#', ''));
      formData.append('SnippedBotFontColor', (this.ConfigData.SnippedBotFontColor ?? '').replace('#', ''));
      formData.append('SnippedSendButtonColor', (this.ConfigData.SnippedSendButtonColor ?? '').replace('#', ''));
      formData.append('SnippedSendButtonVariant', this.ConfigData.SnippedSendButtonVariant || 'default');
      formData.append('SnippedShowHeaderSubtitle', String(this.ConfigData.SnippedShowHeaderSubtitle !== false));
      formData.append('SnippedShowVersion', String(this.ConfigData.SnippedShowVersion !== false));
      formData.append('SnippedShowCharCounter', String(this.ConfigData.SnippedShowCharCounter !== false));
      formData.append('SnippedShowSnippedIcon', String(this.ConfigData.SnippedShowSnippedIcon !== false));
      formData.append('SnippedShowLauncherIcon', String(this.ConfigData.SnippedShowLauncherIcon !== false));
      formData.append('SnippedPanelHeightMode', this.ConfigData.SnippedPanelHeightMode || 'default');
      formData.append('SnippedPanelHeight', this.ConfigData.SnippedPanelHeightMode === 'custom' ? String(this.ConfigData.SnippedPanelHeight ?? '') : '');
      formData.append('setDefaultJson', setDefaultJson);
      if (isChatbotIconEnabled && isImgChat) {
        formData.append('ChatIcon', this.ConfigData.ChatbotIcon ?? '');
      }
      if (this.isFileValue(this.ConfigData.SnippedIcon)) {
        formData.append('SnippedIconImage', this.ConfigData.SnippedIcon);
      }
      if (this.isFileValue(this.ConfigData.SnippedLauncherIcon)) {
        formData.append('SnippedLauncherIconImage', this.ConfigData.SnippedLauncherIcon);
      }
      let data = {
        formData: formData,
      };
      this.$call.UploadTheme(
        data,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.SuccessMessage = this.$t('_SuccessfullySavedTheme');
            this.showSuccess = true;
            clearTimeout(this._addToastTimer);
            this._addToastTimer = setTimeout(() => {
              this.showSuccess = false;
            }, 1500);
            this.dialog = false;
            globalThis.location.reload();
          }
        },
        (err) => {
          console.error(err);
          this.dialog = false;
        }
      );
    },
    handleFileImport() {
      this.$refs.uploader.click();
    },
  },
};
</script>
<style scoped>
/* [D22] Snippet tab: preview sticky left · settings scroll right (was 7 duplicated previews) */
.snippet-tab-row {
  align-items: flex-start;
}
/* snippet preview card taller so the widget mock isn't squished (shared .dialog_div is 500px fixed) */
.snippet-preview-card {
  height: calc(100vh - 150px) !important;
  min-height: 640px !important;
  max-height: 1080px !important;
  /* light gray canvas so the white chat panel doesn't blend in when Panel Border is unset */
  background-color: #F1F1F4 !important;
}
/* clickable color swatch → opens the color picker menu */
.snipped-color-swatch--clickable {
  cursor: pointer;
}
.snipped-color-swatch--clickable:hover {
  outline: 2px solid rgba(15, 23, 42, 0.25);
  outline-offset: 1px;
}
.snippet-preview-col {
  position: sticky;
  top: 12px;
  align-self: flex-start;
}
.snippet-settings-col {
  max-height: calc(100vh - 220px);
  overflow-y: auto;
  padding-right: 12px;
}
.snippet-settings-col > * + * {
  margin-top: 1rem;
}
@media (max-width: 959px), (max-height: 700px) {
  .snippet-preview-col {
    position: static;
  }
  .snippet-settings-col {
    max-height: none;
    overflow-y: visible;
    padding-right: 0;
  }
}

.card {
  border-radius: 10px !important;
  height: auto;
  overflow: visible;
  margin: 0 0 2rem 0;
  padding: 0;
}

.pagin {
  margin-top: 1.5rem;
}

.flex {
  margin: 2rem;
}

.img-intersection {
  width: 100%;
  height: 100%;
  max-width: 100%;
}

.tab-header-row {
  border-bottom: 2px solid #e0e0e0;
  margin-left: 1px !important;
  margin-right: 1px !important;
}

.sticky-header {
  position: sticky;
  top: 0px;
  z-index: 100;
  background-color: #ffffff;
}

.tab-buttons {
  display: flex !important;
  justify-content: start !important;
  gap: 19px !important;
  flex-wrap: nowrap !important;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 8px;
  scrollbar-width: thin;
  scrollbar-color: rgba(56, 89, 208, 0.35) transparent;
}

.tab-buttons::-webkit-scrollbar {
  height: 6px;
}

.tab-buttons::-webkit-scrollbar-track {
  background: transparent;
}

.tab-buttons::-webkit-scrollbar-thumb {
  background: rgba(56, 89, 208, 0.35);
  border-radius: 999px;
}

.tab-btn {
  border: 1px solid #3859d0;
  color: #3859d0;
  border-radius: 50px !important;
  text-transform: none !important;
  padding: 8px 24px !important;
  height: 45px;
  min-width: 100px;
  flex: 0 0 auto;
  transition:
    background 0.2s ease,
    color 0.2s ease,
    border-color 0.2s ease,
    transform 0.2s ease;
}
.tab-btn :deep(.v-btn__content) {
  font-weight: 600 !important;
  font-size: 16px !important;
}

.tab-btn__icon {
  display: block;
  transition: filter 0.2s ease;
}

.tab-btn:hover {
  background-color: #eff4ff !important;
}

.tab-btn--active {
  color: #ffffff !important;
  border-color: transparent !important;
  background: linear-gradient(90deg, #3859d0 0%, #6b8cff 100%) !important;
  box-shadow: 0 10px 20px rgba(56, 89, 208, 0.22) !important;
}

.tab-btn--active:hover {
  background: linear-gradient(90deg, #3150c1 0%, #5f80ef 100%) !important;
  transform: translateY(-1px);
}

.tab-btn--active .tab-btn__icon {
  filter: brightness(0) saturate(100%) invert(100%);
}

.tab-btn--active :deep(.v-icon),
.tab-btn--active :deep(.v-btn__content) {
  color: #ffffff !important;
}

.action-buttons {
  height: 45px;
  flex-shrink: 0;
}
.default-btn {
  border-radius: 50%;
  min-width: 45px !important;
  max-width: 45px !important;
  height: 45px;
}
.save-btn {
  border-radius: 16px;
  height: 45px;
  text-transform: none !important;
  font-size: 15px;
  padding: 0 24px !important;
}

.reset-btn {
  border-radius: 16px;
  height: 45px;
  padding: 0 20px !important;
  outline: auto;
  outline-color: #c9c9c9;
  box-shadow: none !important;
}

.chatbot-icon-selector {
  border: 1px solid rgba(56, 89, 208, 0.14);
  border-radius: 16px;
  padding: 14px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
}

.chatbot-icon-selector__header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.chatbot-icon-selector__preview {
  width: 44px;
  height: 44px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
}

.chatbot-icon-selector__image {
  width: 44px;
  height: 44px;
  border-radius: 999px;
}

.chatbot-icon-selector__text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.chatbot-icon-selector__actions {
  margin-left: auto;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.chatbot-icon-selector__toggle {
  flex: 0 0 auto;
}

.chatbot-icon-selector__toggle-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.chatbot-icon-selector__toggle-label {
  color: #334155;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.2;
  white-space: nowrap;
}

.chatbot-icon-selector--icon-off .chatbot-icon-selector__preview,
.chatbot-icon-selector--icon-off .fullstream-chat-preview-avatar {
  background: #ffffff !important;
}

.chatbot-icon-selector__text label {
  color: #111827;
  font-size: 14px;
  font-weight: 700;
}

.chatbot-icon-selector__text span {
  color: #6b7280;
  font-size: 12px;
}

.chatbot-icon-selector__grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(42px, 1fr));
  gap: 8px;
}

.chatbot-icon-option {
  height: 42px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 12px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    transform 0.2s ease;
}

.chatbot-icon-option:hover,
.chatbot-icon-option--active {
  background: color-mix(in srgb, currentColor 10%, white);
  border-color: currentColor;
  transform: translateY(-1px);
}

.chatbot-icon-option--upload {
  margin: 0;
}

.snipped-color-swatch {
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border: 1px solid rgba(15, 23, 42, 0.18);
  margin-right: 8px;
  flex-shrink: 0;
}

.style-div {
  border-radius: 16px;
  background-color: #e1e1e132;
  padding: 12px 28px;
  height: 400px;
}

.style-div--snippet-icon {
  height: auto !important;
  min-height: 360px;
}

.chatpanel-style-div {
  height: auto !important;
  min-height: 760px;
  padding-bottom: 28px;
  overflow-y: auto;
}

.fullstream-style-div {
  height: auto;
  min-height: 500px;
}

.fullstream-style-div--compact {
  min-height: 360px;
}

.fullstream-style-div--single {
  min-height: auto;
  height: auto;
}

.fullstream-control-group {
  margin-bottom: 20px;
}

.fullstream-control-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.fullstream-control-label {
  display: block;
  margin-bottom: 8px;
  color: #334155;
  font-size: 14px;
  font-weight: 600;
}

/* Helper text under a snippet setting control (explains empty-value / variant behaviour). */
.snipped-control-hint {
  display: block;
  margin-top: 4px;
  color: #71717a;
  font-size: 12px;
}

.fullstream-control-panel {
  padding: 16px;
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 18px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, rgba(248, 250, 252, 0.92) 100%);
  box-shadow: 0 10px 26px rgba(15, 23, 42, 0.05);
}

.fullstream-control-panel--last {
  margin-top: 20px;
}

.fullstream-mini-reset {
  min-width: 36px !important;
  max-width: 36px !important;
  width: 36px;
  height: 36px;
  padding: 0 !important;
}

/* Dialog Card Styles */
.dialog_div {
  background-color: #ffffff;
  box-shadow: rgba(0, 0, 0, 0.11) 0px 4px 22px !important;
  border-radius: 16px;
  max-height: 500px;
  min-height: 500px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.fullstream-preview-card {
  background: #ffffff;
  box-shadow: rgba(0, 0, 0, 0.11) 0px 4px 22px !important;
  border-radius: 16px;
  min-height: 500px;
}

.fullstream-section-preview {
  min-height: auto;
}

.fullstream-preview-offset--chat-accent {
  margin-top: 64px;
}

.fullstream-preview-offset--header-icon {
  margin-top: 52px;
}

.fullstream-text-preview-card,
.fullstream-header-preview-shell,
.fullstream-chat-preview-shell {
  border: 1px solid #e5e7eb;
  border-radius: 20px;
  background: radial-gradient(circle at top right, rgba(56, 89, 208, 0.08), transparent 28%), linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
}

.fullstream-text-preview-card {
  min-height: 468px;
  padding: 40px 32px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center;
  gap: 32px;
}

.fullstream-text-preview-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
}

.fullstream-text-preview-footer {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

.fullstream-preview-kicker {
  display: inline-flex;
  align-self: center;
  margin-bottom: 20px;
  padding: 8px 14px;
  border-radius: 999px;
  background-color: #ebeefa;
  color: #3859d0;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.fullstream-preview-disclaimer-box {
  margin: 28px auto 0;
  max-width: 520px;
  padding: 16px 18px;

  color: #475569;
  font-size: 13px;
  line-height: 1.6;
}

.fullstream-preview-disclaimer-box--below-chat {
  width: 100%;
  max-width: none;
  margin: 0;
  text-align: center;
}

.fullstream-header-preview-shell {
  min-height: 248px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 18px;
}

.fullstream-header-preview-stack {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.fullstream-header-preview-shell--compact {
  min-height: 0;
  padding: 18px;
}

.fullstream-header-preview-label {
  color: #475569;
  font-size: 13px;
  font-weight: 700;
}

.fullstream-header-preview-bar {
  min-height: 84px;
  border-radius: 22px;
  padding: 0 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 14px 32px rgba(15, 23, 42, 0.1);
}

.fullstream-header-preview-spacer {
  width: 24px;
  height: 24px;
}

.fullstream-header-preview-content {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: auto;
  min-width: 0;
}

.fullstream-header-preview-chip {
  display: inline-flex;
  align-items: center;
  padding: 8px 12px;
  border-radius: 999px;
  border: 1px solid currentColor;
  font-size: 12px;
  font-weight: 700;
}

.fullstream-header-preview-topic {
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  font-weight: 600;
}

.fullstream-preview-helper-text {
  color: #64748b;
  font-size: 13px;
  line-height: 1.6;
}

.fullstream-chat-preview-shell {
  min-height: 320px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.fullstream-chat-preview-thread {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.fullstream-chat-preview-row {
  display: flex;
  align-items: flex-end;
  gap: 12px;
}

.fullstream-chat-preview-row--user {
  justify-content: flex-end;
}

.fullstream-chat-preview-avatar {
  width: 38px;
  height: 38px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
}

.fullstream-chat-preview-avatar-image {
  width: 38px;
  height: 38px;
  border-radius: 999px;
}

.fullstream-chat-preview-bubble {
  max-width: 72%;
  border-radius: 18px;
  padding: 12px 16px;
  font-size: 13px;
  line-height: 1.6;
}

.fullstream-chat-preview-bubble--bot {
  background-color: #ffffff;
  color: #334155;
  border: 1px solid rgba(148, 163, 184, 0.2);
}

.fullstream-chat-preview-bubble--user {
  color: #ffffff;
}

.fullstream-chat-preview-composer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 18px;
  border: 1px solid rgba(148, 163, 184, 0.18);
  background-color: rgba(255, 255, 255, 0.94);
}

.fullstream-chat-preview-composer--text-preview {
  width: 100%;
}

.fullstream-chat-preview-placeholder {
  color: #94a3b8;
  font-size: 14px;
}

.fullstream-chat-preview-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.fullstream-chat-preview-send {
  width: 34px;
  height: 34px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 10px 20px rgba(15, 23, 42, 0.12);
}

.fullstream-preview-shell {
  border: 1px solid #e5e7eb;
  border-radius: 20px;
  min-height: 468px;
  background: radial-gradient(circle at top right, rgba(56, 89, 208, 0.08), transparent 28%), linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.fullstream-preview-topbar {
  min-height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  border-bottom: 1px solid rgba(148, 163, 184, 0.18);
  background-color: rgba(255, 255, 255, 0.88);
  backdrop-filter: blur(6px);
}

.fullstream-preview-topbar-spacer {
  width: 24px;
  height: 24px;
}

.fullstream-preview-model-wrap {
  margin-left: auto;
}

.fullstream-preview-model-label {
  color: #71717a;
  font-size: 13px;
  font-weight: 600;
}

.fullstream-preview-body {
  flex: 1;
  padding: 24px 24px 16px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.fullstream-preview-message-row {
  display: flex;
  gap: 12px;
  align-items: flex-end;
}

.fullstream-preview-message-row--user {
  justify-content: flex-end;
}

.fullstream-preview-avatar {
  width: 36px;
  height: 36px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.fullstream-preview-message-bubble {
  max-width: 72%;
  border-radius: 18px;
  padding: 12px 16px;
  font-size: 13px;
  line-height: 1.5;
}

.fullstream-preview-message-bubble--bot {
  background-color: #ffffff;
  color: #334155;
  border: 1px solid rgba(148, 163, 184, 0.2);
}

.fullstream-preview-message-bubble--user {
  background-color: #e5e7eb;
  color: #3f3f46;
}

.fullstream-preview-welcome {
  padding: 18px 8px 8px;
  text-align: center;
}

.fullstream-preview-title {
  margin: 0;
  color: #111827;
  font-size: 32px;
  line-height: 1.15;
  font-weight: 700;
}

.fullstream-preview-subtitle {
  margin: 12px auto 0;
  max-width: 460px;
  color: #71717a;
  font-size: 15px;
  line-height: 1.6;
}

.fullstream-preview-shortcuts {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.fullstream-preview-shortcut-card {
  background-color: rgba(255, 255, 255, 0.82);
  border: 1px solid rgba(148, 163, 184, 0.18);
  border-radius: 18px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: #475569;
  font-size: 12px;
  min-height: 120px;
}

.fullstream-preview-shortcut-card strong {
  color: #0f172a;
  font-size: 14px;
}

.fullstream-preview-shortcut-icon {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
}

.fullstream-preview-footer {
  padding: 16px 20px 20px;
}

.fullstream-preview-composer {
  border-radius: 20px;
  border: 1px solid rgba(148, 163, 184, 0.18);
  background-color: rgba(255, 255, 255, 0.94);
  padding: 12px 14px;
  box-shadow: 0 16px 30px rgba(15, 23, 42, 0.06);
}

.fullstream-preview-input-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.fullstream-preview-icon-btn,
.fullstream-preview-send-btn {
  box-shadow: none !important;
}

.fullstream-preview-input {
  flex: 1;
  min-height: 42px;
  display: flex;
  align-items: center;
  padding: 0 14px;
  border-radius: 14px;
  background-color: #f8fafc;
  color: #687281;
  font-size: 14px;
}

.fullstream-preview-meta {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
}

.fullstream-preview-counter {
  color: #71717a;
  font-size: 10px;
  flex-shrink: 0;
}

.fullstream-preview-disclaimer {
  color: #71717a;
  font-size: 10px;
  line-height: 1.5;
}

@media (max-width: 1264px) {
  .fullstream-preview-shortcuts {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 960px) {
  .tab-header-row {
    row-gap: 12px;
  }

  .fullstream-preview-title {
    font-size: 26px;
  }

  .fullstream-header-preview-bar,
  .fullstream-chat-preview-composer {
    flex-direction: column;
    align-items: flex-start;
  }

  .fullstream-header-preview-content {
    width: 100%;
    margin-left: 0;
    flex-wrap: wrap;
  }

  .fullstream-preview-message-bubble {
    max-width: 100%;
  }

  .fullstream-chat-preview-bubble {
    max-width: 100%;
  }

  .fullstream-preview-meta {
    flex-direction: column;
  }
}

.success-toast {
  position: fixed;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(100deg, #1d863c 0%, #135928 100%) !important;
  color: #ffffff;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  z-index: 2100;
  width: 50%;
  max-width: 700px;
  min-width: 320px;
  justify-content: center;
  padding: 12px;
  border: 1px solid #ffffff;
  gap: 20px;
  margin-top: 140px;
}

.dialog-card {
  border-radius: 12px !important;
}
.cancel-btn {
  text-transform: none;
  font-weight: 600;
  height: 44px;
  min-width: 120px;
  transition: all 0.2s ease;
  box-shadow: none !important;
  color: #646464 !important;
  border-radius: 16px !important;
  border: 1px solid var(--Border, #949aa8) !important;
}
.delete-confirm-btn {
  background: linear-gradient(90deg, #c32e0e 0%, #f67760 100%);
}
.warning-btn {
  border-radius: 16px;
  background: var(--Active-red, #c30000);
  color: white;
  width: 100px;
}
</style>
